var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCulturalSites(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 109,
    viewBox: "0 0 152 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1855_13413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.0458 41.4805H26.1317V42.544H29.0458V41.4805Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3089 42.4531H24.8687V43.5167H30.3089V42.4531Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1507 43.6602H24.0272V44.7237H31.1507V43.6602Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8516 44.6484H23.3256V45.712H31.8516V44.6484Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4968 45.7188H22.6804V46.7823H32.4968V45.7188Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2353 47.6797H20.9419V49.1356H34.2353V47.6797Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2353 49.1133H20.9419V50.5692H34.2353V49.1133Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2353 50.5547H20.9419V52.0106H34.2353V50.5547Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2353 51.9883H20.9419V53.4442H34.2353V51.9883Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8407 39.8575L27.6445 39.4762C27.6183 39.4507 27.5991 39.4474 27.5866 39.4499C27.5722 39.4474 27.5501 39.4507 27.5202 39.4762L27.2948 39.8575C27.273 39.8945 27.2675 39.9408 27.28 39.9826C27.2944 40.0319 27.3317 40.0685 27.3771 40.0785L27.5692 40.12V40.1281L27.587 40.1237L27.6069 40.1281V40.1189L27.7696 40.0789C27.809 40.0693 27.8415 40.0326 27.854 39.983C27.8647 39.9408 27.8599 39.8945 27.8407 39.8575Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7821 40.4716H27.3505C27.2679 40.4716 27.1971 40.412 27.1827 40.3306C27.1627 40.2173 27.2494 40.1133 27.3642 40.1133H27.7685C27.8832 40.1133 27.9699 40.2173 27.9499 40.3306C27.9356 40.412 27.8651 40.4716 27.7821 40.4716Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2417 40.6696H27.8913C27.8913 40.6696 27.7825 40.4416 27.5505 40.4579C27.3181 40.4742 27.2417 40.6696 27.2417 40.6696Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.218 40.668C27.218 40.668 26.8772 40.9123 26.9421 40.9937C27.007 41.0752 27.1856 41.0589 27.1856 41.0589L27.1044 41.4009H28.0787L27.9326 41.0426C27.9326 41.0426 28.3221 41.0426 28.1598 40.8797C28.0702 40.7898 27.8677 40.668 27.8677 40.668H27.218Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7092 46.4755L22.4354 45.9439C22.3989 45.9084 22.3724 45.904 22.3547 45.9073C22.3344 45.9036 22.3038 45.9084 22.2621 45.9439L21.9482 46.4755C21.9179 46.527 21.9102 46.5914 21.9275 46.6499C21.9478 46.7187 21.9994 46.7698 22.0625 46.7831L22.3303 46.8409V46.8524L22.3547 46.8464L22.3827 46.8524V46.8394L22.6092 46.7835C22.6642 46.7698 22.7092 46.7191 22.7269 46.6503C22.7424 46.5914 22.7357 46.527 22.7092 46.4755Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6277 47.3275H22.026C21.9109 47.3275 21.8124 47.2446 21.7921 47.1309C21.7641 46.9732 21.8851 46.8281 22.0448 46.8281H22.6085C22.7682 46.8281 22.8892 46.9732 22.8612 47.1309C22.8416 47.2446 22.7431 47.3275 22.6277 47.3275Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8744 47.6009H22.7793C22.7793 47.6009 22.6276 47.2829 22.3041 47.3059C21.981 47.3281 21.8744 47.6009 21.8744 47.6009Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3643 46.4755L25.0906 45.9439C25.0541 45.9084 25.0275 45.904 25.0098 45.9073C24.9899 45.9036 24.9589 45.9084 24.9172 45.9439L24.6033 46.4755C24.5731 46.527 24.5653 46.5914 24.5826 46.6499C24.6029 46.7187 24.6546 46.7698 24.7177 46.7831L24.9855 46.8409V46.8524L25.0098 46.8464L25.0378 46.8524V46.8394L25.2643 46.7835C25.3193 46.7698 25.3643 46.7191 25.382 46.6503C25.3975 46.5914 25.3909 46.527 25.3643 46.4755Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2828 47.3275H24.6812C24.5661 47.3275 24.4672 47.2446 24.4473 47.1309C24.4193 46.9732 24.5402 46.8281 24.7003 46.8281H25.264C25.4237 46.8281 25.5447 46.9732 25.5171 47.1309C25.4968 47.2446 25.3983 47.3275 25.2828 47.3275Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5295 47.6009H25.4348C25.4348 47.6009 25.2832 47.2829 24.9597 47.3059C24.6361 47.3281 24.5295 47.6009 24.5295 47.6009Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0195 46.4755L27.7458 45.9439C27.7093 45.9084 27.6824 45.904 27.665 45.9073C27.6451 45.9036 27.6141 45.9084 27.5724 45.9439L27.2585 46.4755C27.2283 46.527 27.2205 46.5914 27.2379 46.6499C27.2581 46.7187 27.3098 46.7698 27.3729 46.7831L27.6407 46.8409V46.8524L27.665 46.8464L27.6931 46.8524V46.8394L27.9196 46.7835C27.9745 46.7698 28.0195 46.7191 28.0372 46.6503C28.0527 46.5914 28.0461 46.527 28.0195 46.4755Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.938 47.3275H27.3364C27.2213 47.3275 27.1228 47.2446 27.1025 47.1309C27.0745 46.9732 27.1955 46.8281 27.3556 46.8281H27.9192C28.0789 46.8281 28.1999 46.9732 28.1719 47.1309C28.152 47.2446 28.0531 47.3275 27.938 47.3275Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1848 47.6009H28.0896C28.0896 47.6009 27.938 47.2829 27.6145 47.3059C27.2914 47.3281 27.1848 47.6009 27.1848 47.6009Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0196 43.4638L27.7459 42.9322C27.7094 42.8967 27.6824 42.8922 27.6651 42.8956C27.6452 42.8919 27.6142 42.8967 27.5725 42.9322L27.2586 43.4638C27.2283 43.5153 27.2206 43.5797 27.2379 43.6382C27.2582 43.707 27.3098 43.7581 27.3729 43.7714L27.6407 43.8292V43.8406L27.6651 43.8347L27.6931 43.8406V43.8277L27.9196 43.7718C27.9746 43.7581 28.0196 43.7074 28.0373 43.6385C28.0528 43.5797 28.0461 43.5153 28.0196 43.4638Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9381 44.3158H27.3364C27.2213 44.3158 27.1229 44.2329 27.1026 44.1192C27.0745 43.9615 27.1955 43.8164 27.3556 43.8164H27.9193C28.079 43.8164 28.2 43.9612 28.172 44.1192C28.152 44.2329 28.0532 44.3158 27.9381 44.3158Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1848 44.5892H28.0897C28.0897 44.5892 27.9381 44.2712 27.6146 44.2942C27.2914 44.3167 27.1848 44.5892 27.1848 44.5892Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6747 46.4755L30.401 45.9439C30.3645 45.9084 30.3379 45.904 30.3202 45.9073C30.3003 45.9036 30.2693 45.9084 30.2276 45.9439L29.9137 46.4755C29.8835 46.527 29.8757 46.5914 29.8931 46.6499C29.9134 46.7187 29.965 46.7698 30.0281 46.7831L30.2959 46.8409V46.8524L30.3202 46.8464L30.3483 46.8524V46.8394L30.5748 46.7835C30.6297 46.7698 30.6747 46.7191 30.6924 46.6503C30.7079 46.5914 30.7013 46.527 30.6747 46.4755Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5932 47.3275H29.9916C29.8765 47.3275 29.778 47.2446 29.7577 47.1309C29.7297 46.9732 29.8507 46.8281 30.0104 46.8281H30.5741C30.7338 46.8281 30.8548 46.9732 30.8271 47.1309C30.8068 47.2446 30.7083 47.3275 30.5932 47.3275Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.84 47.6009H30.7448C30.7448 47.6009 30.5932 47.2829 30.2697 47.3059C29.9466 47.3281 29.84 47.6009 29.84 47.6009Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3301 46.4755L33.0564 45.9439C33.0198 45.9084 32.9929 45.904 32.9756 45.9073C32.9556 45.9036 32.9247 45.9084 32.883 45.9439L32.5691 46.4755C32.5388 46.527 32.5311 46.5914 32.5484 46.6499C32.5687 46.7187 32.6203 46.7698 32.6834 46.7831L32.9512 46.8409V46.8524L32.9756 46.8464L33.0036 46.8524V46.8394L33.2301 46.7835C33.2851 46.7698 33.3301 46.7191 33.3478 46.6503C33.3633 46.5914 33.3566 46.527 33.3301 46.4755Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2486 47.3275H32.6469C32.5318 47.3275 32.433 47.2446 32.413 47.1309C32.385 46.9732 32.506 46.8281 32.6661 46.8281H33.2298C33.3895 46.8281 33.5105 46.9732 33.4828 47.1309C33.4622 47.2446 33.3637 47.3275 33.2486 47.3275Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4953 47.6009H33.4002C33.4002 47.6009 33.2486 47.2829 32.925 47.3059C32.6019 47.3281 32.4953 47.6009 32.4953 47.6009Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9418 53.4441L18.8019 55.1229H36.508L34.0792 53.3945L20.9418 53.4441Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4194 55.0781H18.9343V55.787H36.4194V55.0781Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9872 55.8472L21.2967 59.9529V68.4604H24.1449V59.8863L25.0719 55.832L19.9872 55.8472Z",
    fill: "#BAD8DF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M19.9872 55.8472L21.2967 59.9529V68.4604H24.1449V59.8863L25.0719 55.832L19.9872 55.8472Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9872 55.8472L21.2967 59.9529V68.4604H24.1449V59.8863L25.0719 55.832L19.9872 55.8472Z",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3133 56.8697H24.8347L25.0719 55.832L19.9872 55.8472L20.3133 56.8697Z",
    fill: "#69ABB9",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1345 68.3711H22.6878H22.5992H21.2167L20.7891 69.1644V70.4537H22.5992H22.6878H24.5421V69.1644L24.1345 68.3711Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3418 70.3203H22.6907H22.59H21.0119L20.5239 71.1136V72.403H22.59H22.6907H24.807V71.1136L24.3418 70.3203Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8948 72.2695H22.6992H22.5649H20.4667L19.8175 72.8267V73.7321H22.5649H22.6992H25.5134V72.8267L24.8948 72.2695Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7164 55.8472L32.026 59.9529V68.4604H37.7883V59.8863L38.7157 55.832L30.7164 55.8472Z",
    fill: "#BAD8DF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M30.7164 55.8472L32.026 59.9529V68.4604H37.7883V59.8863L38.7157 55.832L30.7164 55.8472Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7164 55.8472L32.026 59.9529V68.4604H37.7883V59.8863L38.7157 55.832L30.7164 55.8472Z",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0429 56.8697H38.4781L38.7157 55.832L30.7164 55.8472L31.0429 56.8697Z",
    fill: "#69ABB9",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1918 68.3711H34.8317H34.6875H32.4317L31.7342 69.1644V70.4537H34.6875H34.8317H37.8569V69.1644L37.1918 68.3711Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5302 70.3203H34.8366H34.6724H32.0984L31.3023 71.1136V72.403H34.6724H34.8366H38.289V71.1136L37.5302 70.3203Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.432 72.2695H34.8502H34.6318H31.2082L30.1495 72.8267V73.7321H34.6318H34.8502H39.4413V72.8267L38.432 72.2695Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.65 42.5391H130.564V41.4755H127.65V42.5391Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.387 43.5156H131.827V42.4521H126.387V43.5156Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.545 44.7266H132.669V43.663H125.545V44.7266Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.844 45.7109H133.37V44.6474H124.844V45.7109Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.199 46.7812H134.015V45.7177H124.199V46.7812Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.46 49.1328H135.754V47.6769H122.46V49.1328Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.46 50.5742H135.754V49.1183H122.46V50.5742Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.46 52.0117H135.754V50.5558H122.46V52.0117Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.46 53.4453H135.754V51.9894H122.46V53.4453Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.855 39.8575L129.051 39.4762C129.077 39.4507 129.096 39.4474 129.109 39.4499C129.123 39.4474 129.145 39.4507 129.175 39.4762L129.401 39.8575C129.422 39.8945 129.428 39.9408 129.415 39.9826C129.401 40.0319 129.364 40.0685 129.318 40.0785L129.126 40.12V40.1281L129.108 40.1237L129.088 40.1281V40.1189L128.925 40.0789C128.886 40.0693 128.854 40.0326 128.841 39.983C128.831 39.9408 128.836 39.8945 128.855 39.8575Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.913 40.4716H129.345C129.428 40.4716 129.498 40.412 129.513 40.3306C129.533 40.2173 129.446 40.1133 129.331 40.1133H128.927C128.812 40.1133 128.726 40.2173 128.746 40.3306C128.76 40.412 128.831 40.4716 128.913 40.4716Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.454 40.6696H128.805C128.805 40.6696 128.913 40.4416 129.145 40.4579C129.377 40.4742 129.454 40.6696 129.454 40.6696Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.478 40.668C129.478 40.668 129.819 40.9123 129.754 40.9937C129.689 41.0752 129.51 41.0589 129.51 41.0589L129.591 41.4009H128.617L128.763 41.0426C128.763 41.0426 128.374 41.0426 128.536 40.8797C128.626 40.7898 128.828 40.668 128.828 40.668H129.478Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.986 46.4755L134.26 45.9439C134.296 45.9084 134.323 45.904 134.341 45.9073C134.361 45.9036 134.392 45.9084 134.433 45.9439L134.747 46.4755C134.777 46.527 134.785 46.5914 134.768 46.6499C134.748 46.7187 134.696 46.7698 134.633 46.7831L134.365 46.8409V46.8524L134.341 46.8464L134.313 46.8524V46.8394L134.086 46.7835C134.031 46.7698 133.986 46.7191 133.968 46.6503C133.953 46.5914 133.96 46.527 133.986 46.4755Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.068 47.3275H134.669C134.784 47.3275 134.883 47.2446 134.903 47.1309C134.931 46.9732 134.81 46.8281 134.651 46.8281H134.087C133.927 46.8281 133.806 46.9732 133.834 47.1309C133.854 47.2446 133.953 47.3275 134.068 47.3275Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.821 47.6009H133.916C133.916 47.6009 134.068 47.2829 134.391 47.3059C134.714 47.3281 134.821 47.6009 134.821 47.6009Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.331 46.4755L131.605 45.9439C131.641 45.9084 131.668 45.904 131.685 45.9073C131.705 45.9036 131.736 45.9084 131.778 45.9439L132.092 46.4755C132.122 46.527 132.13 46.5914 132.113 46.6499C132.092 46.7187 132.041 46.7698 131.978 46.7831L131.71 46.8409V46.8524L131.685 46.8464L131.657 46.8524V46.8394L131.431 46.7835C131.376 46.7698 131.331 46.7191 131.313 46.6503C131.298 46.5914 131.305 46.527 131.331 46.4755Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.413 47.3275H132.014C132.129 47.3275 132.228 47.2446 132.248 47.1309C132.276 46.9732 132.155 46.8281 131.995 46.8281H131.432C131.272 46.8281 131.151 46.9732 131.179 47.1309C131.199 47.2446 131.297 47.3275 131.413 47.3275Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.166 47.6009H131.26C131.26 47.6009 131.412 47.2829 131.736 47.3059C132.059 47.3281 132.166 47.6009 132.166 47.6009Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.676 46.4755L128.95 45.9439C128.986 45.9084 129.013 45.904 129.03 45.9073C129.05 45.9036 129.081 45.9084 129.123 45.9439L129.437 46.4755C129.467 46.527 129.475 46.5914 129.458 46.6499C129.437 46.7187 129.386 46.7698 129.323 46.7831L129.055 46.8409V46.8524L129.03 46.8464L129.002 46.8524V46.8394L128.776 46.7835C128.721 46.7698 128.676 46.7191 128.658 46.6503C128.643 46.5914 128.65 46.527 128.676 46.4755Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.758 47.3275H129.359C129.475 47.3275 129.573 47.2446 129.593 47.1309C129.621 46.9732 129.5 46.8281 129.341 46.8281H128.777C128.617 46.8281 128.496 46.9732 128.524 47.1309C128.544 47.2446 128.642 47.3275 128.758 47.3275Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.511 47.6009H128.606C128.606 47.6009 128.757 47.2829 129.081 47.3059C129.404 47.3281 129.511 47.6009 129.511 47.6009Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.676 43.4638L128.95 42.9322C128.986 42.8967 129.013 42.8922 129.03 42.8956C129.05 42.8919 129.081 42.8967 129.123 42.9322L129.437 43.4638C129.467 43.5153 129.475 43.5797 129.458 43.6382C129.437 43.707 129.386 43.7581 129.323 43.7714L129.055 43.8292V43.8406L129.03 43.8347L129.002 43.8406V43.8277L128.776 43.7718C128.721 43.7581 128.676 43.7074 128.658 43.6385C128.643 43.5797 128.65 43.5153 128.676 43.4638Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.758 44.3158H129.359C129.474 44.3158 129.573 44.2329 129.593 44.1192C129.621 43.9615 129.5 43.8164 129.341 43.8164H128.777C128.617 43.8164 128.496 43.9612 128.524 44.1192C128.544 44.2329 128.642 44.3158 128.758 44.3158Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.511 44.5892H128.606C128.606 44.5892 128.757 44.2712 129.081 44.2942C129.404 44.3167 129.511 44.5892 129.511 44.5892Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.021 46.4755L126.295 45.9439C126.331 45.9084 126.358 45.904 126.375 45.9073C126.395 45.9036 126.426 45.9084 126.468 45.9439L126.782 46.4755C126.812 46.527 126.82 46.5914 126.803 46.6499C126.782 46.7187 126.731 46.7698 126.668 46.7831L126.4 46.8409V46.8524L126.375 46.8464L126.347 46.8524V46.8394L126.121 46.7835C126.066 46.7698 126.021 46.7191 126.003 46.6503C125.988 46.5914 125.994 46.527 126.021 46.4755Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.102 47.3275H126.704C126.819 47.3275 126.918 47.2446 126.938 47.1309C126.966 46.9732 126.845 46.8281 126.685 46.8281H126.121C125.961 46.8281 125.84 46.9732 125.868 47.1309C125.888 47.2446 125.987 47.3275 126.102 47.3275Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.856 47.6009H125.951C125.951 47.6009 126.102 47.2829 126.426 47.3059C126.749 47.3281 126.856 47.6009 126.856 47.6009Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.366 46.4755L123.639 45.9439C123.676 45.9084 123.703 45.904 123.72 45.9073C123.74 45.9036 123.771 45.9084 123.812 45.9439L124.126 46.4755C124.157 46.527 124.164 46.5914 124.147 46.6499C124.127 46.7187 124.075 46.7698 124.012 46.7831L123.744 46.8409V46.8524L123.72 46.8464L123.692 46.8524V46.8394L123.465 46.7835C123.41 46.7698 123.365 46.7191 123.348 46.6503C123.333 46.5914 123.339 46.527 123.366 46.4755Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.447 47.3275H124.049C124.164 47.3275 124.263 47.2446 124.283 47.1309C124.311 46.9732 124.19 46.8281 124.03 46.8281H123.466C123.307 46.8281 123.186 46.9732 123.214 47.1309C123.233 47.2446 123.332 47.3275 123.447 47.3275Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.201 47.6009H123.296C123.296 47.6009 123.447 47.2829 123.771 47.3059C124.094 47.3281 124.201 47.6009 124.201 47.6009Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.754 53.4441L137.893 55.1229H120.188L122.616 53.3945L135.754 53.4441Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.276 55.7891H137.761V55.0802H120.276V55.7891Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.709 55.8472L135.399 59.9529V68.4604H132.551V59.8863L131.624 55.832L136.709 55.8472Z",
    fill: "#BAD8DF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M136.709 55.8472L135.399 59.9529V68.4604H132.551V59.8863L131.624 55.832L136.709 55.8472Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.709 55.8472L135.399 59.9529V68.4604H132.551V59.8863L131.624 55.832L136.709 55.8472Z",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.861 56.8697H136.382L136.709 55.8472L131.624 55.832L131.861 56.8697Z",
    fill: "#69ABB9",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.561 68.3711H134.008H134.096H135.479L135.907 69.1644V70.4537H134.096H134.008H132.154V69.1644L132.561 68.3711Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.354 70.3203H134.005H134.106H135.683L136.171 71.1136V72.403H134.106H134.005H131.888V71.1136L132.354 70.3203Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.801 72.2695H133.997H134.13H136.229L136.878 72.8267V73.7321H134.13H133.997H131.182V72.8267L131.801 72.2695Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.979 55.8472L124.669 59.9529V68.4604H118.907V59.8863L117.98 55.832L125.979 55.8472Z",
    fill: "#BAD8DF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M125.979 55.8472L124.669 59.9529V68.4604H118.907V59.8863L117.98 55.832L125.979 55.8472Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.979 55.8472L124.669 59.9529V68.4604H118.907V59.8863L117.98 55.832L125.979 55.8472Z",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.653 56.8697L125.979 55.8472L117.98 55.832L118.217 56.8697",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.653 56.8697L125.979 55.8472L117.98 55.832L118.217 56.8697",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.504 68.3711H121.864H122.008H124.264L124.961 69.1644V70.4537H122.008H121.864H118.839V69.1644L119.504 68.3711Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.166 70.3203H121.859H122.023H124.597L125.393 71.1136V72.403H122.023H121.859H118.406V71.1136L119.166 70.3203Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.263 72.2695H121.845H122.064H125.487L126.546 72.8267V73.7321H122.064H121.845H117.254V72.8267L118.263 72.2695Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5585 72.1719H53.3076",
    stroke: "#69ABB9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7599 72.4414H42.779",
    stroke: "#69ABB9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.949 36.4688H53.9683V39.5705H100.949V36.4688Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2281 26.439C65.961 23.7685 63.7149 21.6836 60.9837 21.6836C58.2521 21.6836 56.006 23.7685 55.7393 26.439H66.2281Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.612 26.439C64.4272 23.7685 62.8735 21.6836 60.9837 21.6836C59.0939 21.6836 57.5398 23.7685 57.3553 26.439H64.612Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.806 26.439C62.7131 23.7685 61.9329 21.6836 60.9834 21.6836C60.0342 21.6836 59.2537 23.7685 59.1611 26.439H62.806Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2013 26.4375H55.739V27.8268H66.2013V26.4375Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9267 25.4808C55.8455 25.757 55.7876 26.0428 55.7526 26.3356H66.2019V26.2275C66.1658 25.9724 66.1123 25.7229 66.0411 25.4805L55.9267 25.4808Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2013 27.7188H55.739V28.5735H66.2013V27.7188Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2016 30.5053H53.5489L55.7389 28.4648H66.2016V30.5053Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1765 24.9062C56.9663 24.9062 56.7955 25.0773 56.7955 25.2886V26.2374H57.5572V25.2886C57.5572 25.0773 57.3868 24.9062 57.1765 24.9062Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5132 24.9062C64.3029 24.9062 64.1321 25.0773 64.1321 25.2886V26.2374H64.8939V25.2886C64.8942 25.0773 64.7238 24.9062 64.5132 24.9062Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3455 19.1121L61.0043 18.4491C60.9589 18.4051 60.9253 18.3991 60.9036 18.4036C60.8785 18.3991 60.8401 18.4051 60.7881 18.4491L60.3967 19.1121C60.3587 19.1761 60.3495 19.2565 60.3709 19.3298C60.3964 19.4157 60.4606 19.4793 60.5395 19.496L60.8733 19.5678V19.5819L60.9039 19.5745L60.939 19.5819V19.5656L61.2216 19.496C61.2902 19.479 61.3462 19.4153 61.3684 19.3298C61.3868 19.2565 61.3787 19.1761 61.3455 19.1121Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.244 20.1738H60.4937C60.3502 20.1738 60.227 20.0705 60.2019 19.9284C60.1673 19.7314 60.3181 19.5508 60.5173 19.5508H61.2204C61.4196 19.5508 61.5705 19.7314 61.5358 19.9284C61.5107 20.0701 61.3875 20.1738 61.244 20.1738Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3046 20.5143H61.4333C61.4333 20.5143 61.2441 20.1178 60.8409 20.146C60.4374 20.1745 60.3046 20.5143 60.3046 20.5143Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2632 20.5156C60.2632 20.5156 59.6708 20.9406 59.7836 21.082C59.8965 21.2238 60.2068 21.1953 60.2068 21.1953L60.0658 21.7898H61.759L61.5052 21.1668C61.5052 21.1668 62.1825 21.1668 61.9003 20.8836C61.7443 20.7274 61.3924 20.5156 61.3924 20.5156H60.2632Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8591 21.793V26.3806",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5489 30.5115L55.5357 33.1665V39.6136H57.324V33.0998L59.046 30.5078L53.5489 30.5115Z",
    fill: "#BAD8DF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M53.5489 30.5115L55.5357 33.1665V39.6136H57.324V33.0998L59.046 30.5078L53.5489 30.5115Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5489 30.5115L55.5357 33.1665V39.6136H57.324V33.0998L59.046 30.5078L53.5489 30.5115Z",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3165 31.5373H58.3621L59.046 30.5078L53.5489 30.5115L54.3165 31.5373Z",
    fill: "#69ABB9",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2848 30.5115L65.2716 33.1665V39.6136H67.0599V33.0998L68.7819 30.5078L63.2848 30.5115Z",
    fill: "#BAD8DF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M63.2848 30.5115L65.2716 33.1665V39.6136H67.0599V33.0998L68.7819 30.5078L63.2848 30.5115Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2848 30.5115L65.2716 33.1665V39.6136H67.0599V33.0998L68.7819 30.5078L63.2848 30.5115Z",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0524 31.5373H68.098L68.7819 30.5078L63.2848 30.5115L64.0524 31.5373Z",
    fill: "#69ABB9",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.65 36.1433C122.135 31.9521 117.795 28.6797 112.517 28.6797C107.239 28.6797 102.899 31.9521 102.383 36.1433H122.65Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.528 36.1433C119.171 31.9521 116.168 28.6797 112.517 28.6797C108.865 28.6797 105.863 31.9521 105.506 36.1433H119.528Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.038 36.1433C115.859 31.9521 114.351 28.6797 112.517 28.6797C110.683 28.6797 109.175 31.9521 108.995 36.1433H116.038Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.599 36.1484H102.383V38.3288H122.599V36.1484Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.045 23.4538L112.51 22.4133C112.438 22.344 112.386 22.3348 112.351 22.3418C112.312 22.3348 112.252 22.344 112.17 22.4133L111.556 23.4538C111.496 23.5545 111.481 23.6804 111.515 23.7951C111.555 23.9299 111.656 24.0298 111.78 24.0561L112.303 24.1687V24.1909L112.351 24.179L112.406 24.1909V24.1657L112.85 24.0561C112.957 24.0295 113.046 23.9295 113.08 23.7951C113.11 23.6804 113.097 23.5542 113.045 23.4538Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.885 25.1222H111.708C111.482 25.1222 111.29 24.96 111.25 24.7372C111.195 24.4281 111.432 24.1445 111.745 24.1445H112.848C113.161 24.1445 113.398 24.4281 113.343 24.7372C113.304 24.9597 113.111 25.1222 112.885 25.1222Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.411 25.6582H113.182C113.182 25.6582 112.885 25.036 112.252 25.0804C111.62 25.1252 111.411 25.6582 111.411 25.6582Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.346 25.6562C111.346 25.6562 110.416 26.7612 110.593 26.9837C110.77 27.2058 111.257 27.1614 111.257 27.1614L111.036 27.6563H113.693L113.295 27.117C113.295 27.117 114.181 27.2414 113.915 26.6724C113.61 26.0209 113.118 25.6562 113.118 25.6562H111.346Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.276 28.8594V36.0594",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.036 27.6602C111.036 27.6602 108.675 28.5164 108.344 29.3141H117.02C117.02 29.3141 115.797 28.1995 113.693 27.6602H111.036Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.366 38.418H99.3147V39.4815H125.366V38.418Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.392 35.1406C103.929 35.1406 103.554 35.5175 103.554 35.9824V38.4193H105.232V35.9824C105.231 35.5178 104.856 35.1406 104.392 35.1406Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.164 35.1406C111.7 35.1406 111.325 35.5175 111.325 35.9824V38.4193H113.002V35.9824C113.002 35.5178 112.627 35.1406 112.164 35.1406Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.199 35.1406C119.736 35.1406 119.361 35.5175 119.361 35.9824V38.4193H121.038V35.9824C121.039 35.5178 120.663 35.1406 120.199 35.1406Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5681 26.439C90.8351 23.7685 93.0813 21.6836 95.8125 21.6836C98.544 21.6836 100.79 23.7685 101.057 26.439H90.5681Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1841 26.439C92.3689 23.7685 93.9226 21.6836 95.8124 21.6836C97.7022 21.6836 99.2563 23.7685 99.4408 26.439H92.1841Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9898 26.439C94.0828 23.7685 94.863 21.6836 95.8125 21.6836C96.7616 21.6836 97.5422 23.7685 97.6347 26.439H93.9898Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5946 27.8242H101.057V26.4349H90.5946V27.8242Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.87 25.4808C100.951 25.757 101.009 26.0428 101.044 26.3356H90.5943V26.2275C90.6304 25.9724 90.6839 25.7229 90.7551 25.4805L100.87 25.4808Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5946 28.5781H101.057V27.7234H90.5946V28.5781Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5947 30.5053H103.247L101.057 28.4648H90.5947V30.5053Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6196 24.9062C99.8299 24.9062 100.001 25.0773 100.001 25.2886V26.2374H99.239V25.2886C99.2386 25.0773 99.409 24.9062 99.6196 24.9062Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2827 24.9062C92.4929 24.9062 92.6637 25.0773 92.6637 25.2886V26.2374H91.902V25.2886C91.902 25.0773 92.0724 24.9062 92.2827 24.9062Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4503 19.1121L95.7915 18.4491C95.8369 18.4051 95.8705 18.3991 95.8922 18.4036C95.9173 18.3991 95.9557 18.4051 96.0077 18.4491L96.3991 19.1121C96.4371 19.1761 96.4467 19.2565 96.4249 19.3298C96.3994 19.4157 96.3352 19.4793 96.2563 19.496L95.9225 19.5678V19.5819L95.8918 19.5745L95.8568 19.5819V19.5656L95.5742 19.496C95.5056 19.479 95.4496 19.4153 95.4274 19.3298C95.409 19.2565 95.4175 19.1761 95.4503 19.1121Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5521 20.1738H96.3024C96.4463 20.1738 96.5692 20.0705 96.5942 19.9284C96.6293 19.7314 96.478 19.5508 96.2788 19.5508H95.5757C95.3765 19.5508 95.2257 19.7314 95.2603 19.9284C95.2854 20.0701 95.4083 20.1738 95.5521 20.1738Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4916 20.5143H95.3629C95.3629 20.5143 95.5521 20.1178 95.9553 20.146C96.3585 20.1745 96.4916 20.5143 96.4916 20.5143Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.533 20.5156C96.533 20.5156 97.1254 20.9406 97.0129 21.082C96.9 21.2238 96.5898 21.1953 96.5898 21.1953L96.7311 21.7898H95.0379L95.2917 21.1668C95.2917 21.1668 94.6144 21.1668 94.8966 20.8836C95.0526 20.7274 95.4046 20.5156 95.4046 20.5156H96.533Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9371 21.793V26.3806",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.247 30.5115L101.261 33.1665V39.6136H99.4723V33.0998L97.7503 30.5078L103.247 30.5115Z",
    fill: "#BAD8DF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M103.247 30.5115L101.261 33.1665V39.6136H99.4723V33.0998L97.7503 30.5078L103.247 30.5115Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.247 30.5115L101.261 33.1665V39.6136H99.4723V33.0998L97.7503 30.5078L103.247 30.5115Z",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4342 31.5373H102.48L103.247 30.5115L97.7503 30.5078L98.4342 31.5373Z",
    fill: "#69ABB9",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5114 30.5115L91.5243 33.1665V39.6136H89.7363V33.0998L88.014 30.5078L93.5114 30.5115Z",
    fill: "#BAD8DF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M93.5114 30.5115L91.5243 33.1665V39.6136H89.7363V33.0998L88.014 30.5078L93.5114 30.5115Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5114 30.5115L91.5243 33.1665V39.6136H89.7363V33.0998L88.014 30.5078L93.5114 30.5115Z",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6979 31.5373H92.7438L93.5114 30.5115L88.014 30.5078L88.6979 31.5373Z",
    fill: "#69ABB9",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6084 36.1433C54.0927 31.9521 49.7528 28.6797 44.4751 28.6797C39.1975 28.6797 34.8576 31.9521 34.3419 36.1433H54.6084Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4857 36.1433C51.129 31.9521 48.1263 28.6797 44.4747 28.6797C40.8235 28.6797 37.8208 31.9521 37.4641 36.1433H51.4857Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9965 36.1433C47.8172 31.9521 46.3092 28.6797 44.4752 28.6797C42.6411 28.6797 41.1331 31.9521 40.9538 36.1433H47.9965Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5567 36.1484H34.3416V38.3288H54.5567V36.1484Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0034 23.4538L44.4678 22.4133C44.3966 22.344 44.3438 22.3348 44.3099 22.3418C44.2704 22.3348 44.2103 22.344 44.1284 22.4133L43.5142 23.4538C43.4548 23.5545 43.4397 23.6804 43.4736 23.7951C43.5135 23.9299 43.6145 24.0298 43.7381 24.0561L44.2619 24.1687V24.1909L44.3099 24.179L44.3648 24.1909V24.1657L44.8082 24.0561C44.916 24.0295 45.0041 23.9295 45.0388 23.7951C45.0683 23.6804 45.055 23.5542 45.0034 23.4538Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8438 25.1222H43.6663C43.4409 25.1222 43.248 24.96 43.2085 24.7372C43.1539 24.4281 43.3908 24.1445 43.7036 24.1445H44.8069C45.1197 24.1445 45.3565 24.4281 45.302 24.7372C45.2625 24.9597 45.0692 25.1222 44.8438 25.1222Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3694 25.6582H45.1411C45.1411 25.6582 44.8442 25.036 44.2112 25.0804C43.5778 25.1252 43.3694 25.6582 43.3694 25.6582Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3044 25.6562C43.3044 25.6562 42.3744 26.7612 42.5515 26.9837C42.7285 27.2058 43.2158 27.1614 43.2158 27.1614L42.9945 27.6563H45.6519L45.2535 27.117C45.2535 27.117 46.14 27.2414 45.8736 26.6724C45.5686 26.0209 45.0765 25.6562 45.0765 25.6562H43.3044Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2342 28.8594V36.0594",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9944 27.6602C42.9944 27.6602 40.6339 28.5164 40.3027 29.3141H48.9788C48.9788 29.3141 47.7556 28.1995 45.6515 27.6602H42.9944Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5575 38.418H31.2728V39.4815H55.5575V38.418Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3508 35.1406C35.8875 35.1406 35.512 35.5175 35.512 35.9824V38.4193H37.19V35.9824C37.1896 35.5178 36.8141 35.1406 36.3508 35.1406Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1217 35.1406C43.6584 35.1406 43.2828 35.5175 43.2828 35.9824V38.4193H44.9609V35.9824C44.9609 35.5178 44.585 35.1406 44.1217 35.1406Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1579 35.1406C51.6946 35.1406 51.3191 35.5175 51.3191 35.9824V38.4193H52.9968V35.9824C52.9968 35.5178 52.6213 35.1406 52.1579 35.1406Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5602 37.2656C58.365 37.2656 58.2068 37.4244 58.2068 37.6203V38.8611H58.9132V37.6203C58.9136 37.4244 58.7553 37.2656 58.5602 37.2656Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9734 37.2656C59.7782 37.2656 59.62 37.4244 59.62 37.6203V38.8611H60.3264V37.6203C60.3264 37.4244 60.1682 37.2656 59.9734 37.2656Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3862 37.2656C61.1911 37.2656 61.0328 37.4244 61.0328 37.6203V38.8611H61.7393V37.6203C61.7393 37.4244 61.5814 37.2656 61.3862 37.2656Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.799 37.2656C62.6039 37.2656 62.446 37.4244 62.446 37.6203V38.8611H63.1524V37.6203C63.1524 37.4244 62.9941 37.2656 62.799 37.2656Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2119 37.2656C64.0168 37.2656 63.8585 37.4244 63.8585 37.6203V38.8611H64.5649V37.6203C64.5653 37.4244 64.407 37.2656 64.2119 37.2656Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.559 37.2656C92.3639 37.2656 92.2056 37.4244 92.2056 37.6203V38.8611H92.912V37.6203C92.9124 37.4244 92.7542 37.2656 92.559 37.2656Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9719 37.2656C93.7767 37.2656 93.6185 37.4244 93.6185 37.6203V38.8611H94.3249V37.6203C94.3253 37.4244 94.167 37.2656 93.9719 37.2656Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3851 37.2656C95.1899 37.2656 95.0317 37.4244 95.0317 37.6203V38.8611H95.7381V37.6203C95.7381 37.4244 95.5802 37.2656 95.3851 37.2656Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7979 37.2656C96.6027 37.2656 96.4445 37.4244 96.4445 37.6203V38.8611H97.1509V37.6203C97.1512 37.4244 96.993 37.2656 96.7979 37.2656Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2108 37.2656C98.0156 37.2656 97.8574 37.4244 97.8574 37.6203V38.8611H98.5638V37.6203C98.5641 37.4244 98.4059 37.2656 98.2108 37.2656Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7784 41.2109L31.3614 44.3568V51.6238H36.9249H58.0748V45.9519H63.5055V51.8008H93.0947V46.0803H98.5184V51.8008H125.586V44.2683L127.662 41.2109H28.7784Z",
    fill: "#BAD8DF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M28.7784 41.2109L31.3614 44.3568V51.6238H36.9249H58.0748V45.9519H63.5055V51.8008H93.0947V46.0803H98.5184V51.8008H125.586V44.2683L127.662 41.2109H28.7784Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7784 41.2109L31.3614 44.3568V51.6238H36.9249H58.0748V45.9519H63.5055V51.8008H93.0947V46.0803H98.5184V51.8008H125.586V44.2683L127.662 41.2109H28.7784Z",
    stroke: "#69ABB9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4669 41.2109L42.5558 43.4816V51.6238H58.0748V45.9519H63.5055V51.6564H93.0947V46.0803H98.5184V51.6564H116.069V44.6781L119.524 41.2109H40.4669Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8261 55.5547H36.12V74.169H64.8261V55.5547Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5191 56.0547H35.6884V57.6498H44.5191V56.0547Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2185 57.635V71.0297L34.7172 73.068V74.1315H45.4908V72.9795L44.0779 70.6751V57.5977L36.2185 57.635Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0441 56.6758V71.0322",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3116 68.4612L41.6934 68.0625L41.0751 68.4612V70.2336H42.3116V68.4612Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4981 56.0547H45.6674V57.6498H54.4981V56.0547Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1971 57.635V71.0297L44.6957 73.068V74.1315H55.4697V72.9795L54.0565 70.6751V57.5977L46.1971 57.635Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0231 56.6758V71.0322",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2904 68.4612L51.6725 68.0625L51.0543 68.4612V70.2336H52.2904V68.4612Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8287 70.9062H53.1277",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.21 71.7148H43.1391",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.21 67.4609H63.2849",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.21 66.5312H63.2849",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.21 65.6016H63.2849",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6372 56.3633V70.9929",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1266 59.8828H59.0671V63.4951H62.1266V59.8828Z",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5271 59.7969H57.897V61.332H58.5271V59.7969Z",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2963 59.7969H62.6663V61.332H63.2963V59.7969Z",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2963 62.4141H62.6663V63.9492H63.2963V62.4141Z",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5271 62.6875H57.897V64.2226H58.5271V62.6875Z",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5865 59.8828H50.4559V63.4951H52.5865V59.8828Z",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0796 59.7969H49.641V61.332H50.0796V59.7969Z",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.401 59.7969H52.9624V61.332H53.401V59.7969Z",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.401 62.4141H52.9624V63.9492H53.401V62.4141Z",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0796 62.6875H49.641V64.2226H50.0796V62.6875Z",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7938 59.8828H40.4647V63.4951H42.7938V59.8828Z",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0538 59.7969H39.5742V61.332H40.0538V59.7969Z",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6843 59.7969H43.2047V61.332H43.6843V59.7969Z",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6843 62.4141H43.2047V63.9492H43.6843V62.4141Z",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0538 62.6875H39.5742V64.2226H40.0538V62.6875Z",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6931 60.1016H44.7027V63.4495H45.6931V60.1016Z",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0777 60.1016H47.0872V63.4495H48.0777V60.1016Z",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1429 60.1016H37.1524V63.4495H38.1429V60.1016Z",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8058 60.1016H54.8153V63.4495H55.8058V60.1016Z",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.865 42.918H49.8811V44.007H52.865V42.918Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1584 43.9219H48.5879V45.0109H54.1584V43.9219Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0205 45.1562H47.7262V46.2453H55.0205V45.1562Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7383 46.1641H47.0079V47.2531H55.7383V46.1641Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3989 47.2656H46.3472V48.3547H56.3989V47.2656Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6313 41.2617L51.4303 40.8711C51.4033 40.8452 51.3838 40.8419 51.3709 40.8445C51.3561 40.8419 51.3336 40.8452 51.3026 40.8711L51.0721 41.2617C51.0496 41.2994 51.044 41.3468 51.057 41.3898C51.0717 41.4405 51.1097 41.4779 51.1562 41.4879L51.3528 41.5301V41.5382L51.3709 41.5338L51.3915 41.5382V41.5286L51.5579 41.4875C51.5985 41.4775 51.6313 41.4401 51.6446 41.3894C51.6556 41.3468 51.6509 41.2994 51.6313 41.2617Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5715 41.8907H51.1295C51.0447 41.8907 50.9724 41.8296 50.9576 41.7459C50.937 41.63 51.0259 41.5234 51.1436 41.5234H51.5578C51.6751 41.5234 51.764 41.63 51.7437 41.7459C51.7286 41.8299 51.6559 41.8907 51.5715 41.8907Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0178 42.0889H51.6829C51.6829 42.0889 51.5715 41.8553 51.3335 41.8719C51.0963 41.8886 51.0178 42.0889 51.0178 42.0889Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9934 42.0898C50.9934 42.0898 50.6441 42.3401 50.7109 42.4237C50.7773 42.507 50.9602 42.4904 50.9602 42.4904L50.8772 42.8409H51.8747L51.7249 42.4737C51.7249 42.4737 52.1241 42.4737 51.9577 42.3068C51.8658 42.2146 51.6585 42.0898 51.6585 42.0898H50.9934Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3768 48.0396L46.0968 47.4955C46.0596 47.4592 46.0319 47.4544 46.0142 47.4581C45.9936 47.4544 45.9622 47.4592 45.9194 47.4955L45.5981 48.0396C45.5671 48.0922 45.5594 48.1581 45.5771 48.2181C45.5977 48.2884 45.6509 48.3406 45.7154 48.3547L45.9895 48.4135V48.425L46.0146 48.4187L46.0434 48.425V48.4117L46.2754 48.3543C46.3318 48.3402 46.3779 48.288 46.396 48.2177C46.4108 48.1585 46.4041 48.0926 46.3768 48.0396Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2935 48.9139H45.6775C45.5594 48.9139 45.4587 48.8292 45.4381 48.7126C45.4093 48.5508 45.5332 48.4023 45.697 48.4023H46.2743C46.4381 48.4023 46.5617 48.5508 46.5333 48.7126C46.5123 48.8292 46.4115 48.9139 46.2935 48.9139Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5222 49.1939H46.4488C46.4488 49.1939 46.2935 48.8685 45.9622 48.8918C45.6313 48.9148 45.5222 49.1939 45.5222 49.1939Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0958 48.0396L48.8158 47.4955C48.7786 47.4592 48.7509 47.4544 48.7332 47.4581C48.7125 47.4544 48.6812 47.4592 48.6384 47.4955L48.3171 48.0396C48.2861 48.0922 48.2784 48.1581 48.2961 48.2181C48.3167 48.2884 48.3699 48.3406 48.4344 48.3547L48.7085 48.4135V48.425L48.7336 48.4187L48.7623 48.425V48.4117L48.9944 48.3543C49.0508 48.3402 49.0969 48.288 49.115 48.2177C49.1298 48.1585 49.1227 48.0926 49.0958 48.0396Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0121 48.9139H48.3961C48.2781 48.9139 48.1773 48.8292 48.1567 48.7126C48.1279 48.5508 48.2519 48.4023 48.4156 48.4023H48.993C49.1567 48.4023 49.2807 48.5508 49.2519 48.7126C49.2312 48.8292 49.1302 48.9139 49.0121 48.9139Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2408 49.1939H49.1674C49.1674 49.1939 49.0121 48.8685 48.6809 48.8918C48.3496 48.9151 48.2408 49.1939 48.2408 49.1939Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8145 48.0396L51.5345 47.4955C51.4973 47.4592 51.4696 47.4544 51.4519 47.4581C51.4312 47.4544 51.3999 47.4592 51.3571 47.4955L51.0358 48.0396C51.0048 48.0922 50.9971 48.1581 51.0148 48.2181C51.0354 48.2884 51.0885 48.3406 51.1531 48.3547L51.4272 48.4135V48.425L51.4523 48.4187L51.481 48.425V48.4117L51.7131 48.3543C51.7695 48.3402 51.8156 48.288 51.8337 48.2177C51.8484 48.1585 51.8418 48.0926 51.8145 48.0396Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7312 48.9139H51.1152C50.9971 48.9139 50.8964 48.8292 50.8757 48.7126C50.847 48.5508 50.9709 48.4023 51.1347 48.4023H51.7116C51.8754 48.4023 51.999 48.5508 51.9706 48.7126C51.9499 48.8292 51.8489 48.9139 51.7312 48.9139Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9598 49.1939H51.8865C51.8865 49.1939 51.7312 48.8685 51.3999 48.8918C51.0687 48.9148 50.9598 49.1939 50.9598 49.1939Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8145 44.9537L51.5345 44.4095C51.4973 44.3732 51.4696 44.3684 51.4519 44.3721C51.4312 44.3684 51.3999 44.3732 51.3571 44.4095L51.0358 44.9537C51.0048 45.0063 50.9971 45.0722 51.0148 45.1321C51.0354 45.2025 51.0885 45.2546 51.1531 45.2687L51.4272 45.3276V45.339L51.4523 45.3328L51.481 45.339V45.3257L51.7131 45.2683C51.7695 45.2543 51.8156 45.2021 51.8337 45.1317C51.8484 45.0721 51.8418 45.0063 51.8145 44.9537Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7312 45.828H51.1152C50.9971 45.828 50.8964 45.7432 50.8757 45.6266C50.847 45.4648 50.9709 45.3164 51.1347 45.3164H51.7116C51.8754 45.3164 51.999 45.4648 51.9706 45.6266C51.9499 45.7429 51.8489 45.828 51.7312 45.828Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9598 46.108H51.8865C51.8865 46.108 51.7312 45.7826 51.3999 45.8059C51.0687 45.8292 50.9598 46.108 50.9598 46.108Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5335 48.0396L54.2535 47.4955C54.2163 47.4592 54.1886 47.4544 54.1709 47.4581C54.1502 47.4544 54.1189 47.4592 54.0761 47.4955L53.7548 48.0396C53.7238 48.0922 53.7161 48.1581 53.7338 48.2181C53.7544 48.2884 53.8075 48.3406 53.8721 48.3547L54.1462 48.4135V48.425L54.1713 48.4187L54.2 48.425V48.4117L54.4321 48.3543C54.4885 48.3402 54.5346 48.288 54.5527 48.2177C54.5674 48.1585 54.5604 48.0926 54.5335 48.0396Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4498 48.9139H53.8338C53.7157 48.9139 53.6147 48.8292 53.5944 48.7126C53.5656 48.5508 53.6895 48.4023 53.8533 48.4023H54.4306C54.5944 48.4023 54.718 48.5508 54.6896 48.7126C54.6689 48.8292 54.5679 48.9139 54.4498 48.9139Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6785 49.1939H54.6051C54.6051 49.1939 54.4498 48.8685 54.1185 48.8918C53.7877 48.9148 53.6785 49.1939 53.6785 49.1939Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2523 48.0396L56.9723 47.4955C56.9351 47.4592 56.9074 47.4544 56.8897 47.4581C56.869 47.4544 56.8377 47.4592 56.7949 47.4955L56.4736 48.0396C56.4426 48.0922 56.4345 48.1581 56.4526 48.2181C56.4732 48.2884 56.5263 48.3406 56.5909 48.3547L56.865 48.4135V48.425L56.89 48.4187L56.9188 48.425V48.4117L57.1508 48.3543C57.2073 48.3402 57.2534 48.288 57.2715 48.2177C57.2862 48.1585 57.2792 48.0926 57.2523 48.0396Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1689 48.9139H56.5528C56.4348 48.9139 56.3341 48.8292 56.3134 48.7126C56.2847 48.5508 56.4086 48.4023 56.5724 48.4023H57.1497C57.3135 48.4023 57.4374 48.5508 57.4086 48.7126C57.3876 48.8292 57.2865 48.9139 57.1689 48.9139Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3975 49.1939H57.3242C57.3242 49.1939 57.1689 48.8685 56.8376 48.8918C56.5063 48.9151 56.3975 49.1939 56.3975 49.1939Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1662 42.918H40.1823V44.007H43.1662V42.918Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4595 43.9219H38.889V45.0109H44.4595V43.9219Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3216 45.1562H38.0273V46.2453H45.3216V45.1562Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0395 46.1641H37.3091V47.2531H46.0395V46.1641Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7002 47.2656H36.6485V48.3547H46.7002V47.2656Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9324 41.2617L41.7313 40.8711C41.7048 40.8452 41.6848 40.8419 41.6719 40.8445C41.6572 40.8419 41.6347 40.8452 41.6037 40.8711L41.3731 41.2617C41.351 41.2994 41.3451 41.3468 41.358 41.3898C41.3728 41.4405 41.4108 41.4779 41.4572 41.4879L41.6539 41.5301V41.5382L41.6719 41.5338L41.6926 41.5382V41.5286L41.859 41.4875C41.8995 41.4775 41.9324 41.4401 41.9456 41.3894C41.9567 41.3468 41.9519 41.2994 41.9324 41.2617Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8726 41.8907H41.4307C41.3462 41.8907 41.2735 41.8296 41.2588 41.7459C41.2381 41.63 41.327 41.5234 41.4447 41.5234H41.859C41.9763 41.5234 42.0652 41.63 42.0449 41.7459C42.0298 41.8299 41.9571 41.8907 41.8726 41.8907Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3189 42.0889H41.984C41.984 42.0889 41.8726 41.8553 41.6347 41.8719C41.3975 41.8886 41.3189 42.0889 41.3189 42.0889Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2946 42.0898C41.2946 42.0898 40.9453 42.3401 41.012 42.4237C41.0784 42.507 41.2614 42.4904 41.2614 42.4904L41.1784 42.8409H42.1758L42.0261 42.4737C42.0261 42.4737 42.4252 42.4737 42.2588 42.3068C42.167 42.2146 41.9597 42.0898 41.9597 42.0898H41.2946Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.678 48.0396L36.398 47.4955C36.3607 47.4592 36.3331 47.4544 36.3154 47.4581C36.2947 47.4544 36.2633 47.4592 36.2206 47.4955L35.8993 48.0396C35.8683 48.0922 35.8605 48.1581 35.8782 48.2181C35.8989 48.2884 35.952 48.3406 36.0166 48.3547L36.2906 48.4135V48.425L36.3157 48.4187L36.3445 48.425V48.4117L36.5765 48.3543C36.633 48.3402 36.6791 48.288 36.6971 48.2177C36.7119 48.1585 36.7053 48.0926 36.678 48.0396Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5947 48.9139H35.9786C35.8606 48.9139 35.7599 48.8292 35.7392 48.7126C35.7104 48.5508 35.8344 48.4023 35.9982 48.4023H36.5755C36.7393 48.4023 36.8632 48.5508 36.8344 48.7126C36.8134 48.8292 36.7127 48.9139 36.5947 48.9139Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8233 49.1939H36.7499C36.7499 49.1939 36.5946 48.8685 36.2634 48.8918C35.9321 48.9151 35.8233 49.1939 35.8233 49.1939Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.397 48.0396L39.117 47.4955C39.0798 47.4592 39.0521 47.4544 39.0344 47.4581C39.0138 47.4544 38.9824 47.4592 38.9396 47.4955L38.6183 48.0396C38.5873 48.0922 38.5796 48.1581 38.5973 48.2181C38.6179 48.2884 38.6711 48.3406 38.7356 48.3547L39.0097 48.4135V48.425L39.0348 48.4187L39.0636 48.425V48.4117L39.2956 48.3543C39.352 48.3402 39.3981 48.288 39.4162 48.2177C39.431 48.1585 39.424 48.0926 39.397 48.0396Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3133 48.9139H38.6973C38.5792 48.9139 38.4785 48.8292 38.4579 48.7126C38.4295 48.5508 38.553 48.4023 38.7168 48.4023H39.2941C39.4579 48.4023 39.5815 48.5508 39.5531 48.7126C39.5324 48.8292 39.4314 48.9139 39.3133 48.9139Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.542 49.1939H39.4686C39.4686 49.1939 39.3133 48.8685 38.9821 48.8918C38.6512 48.9148 38.542 49.1939 38.542 49.1939Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1157 48.0396L41.8357 47.4955C41.7985 47.4592 41.7712 47.4544 41.7531 47.4581C41.7324 47.4544 41.7011 47.4592 41.6583 47.4955L41.337 48.0396C41.306 48.0922 41.2982 48.1581 41.3156 48.2181C41.3362 48.2884 41.3894 48.3406 41.4539 48.3547L41.728 48.4135V48.425L41.7531 48.4187L41.7819 48.425V48.4117L42.0139 48.3543C42.0703 48.3402 42.1164 48.288 42.1345 48.2177C42.1496 48.1585 42.143 48.0926 42.1157 48.0396Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0323 48.9139H41.4163C41.2983 48.9139 41.1976 48.8292 41.1769 48.7126C41.1481 48.5508 41.2721 48.4023 41.4358 48.4023H42.0132C42.1769 48.4023 42.3005 48.5508 42.2721 48.7126C42.2511 48.8292 42.15 48.9139 42.0323 48.9139Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.261 49.1939H42.1876C42.1876 49.1939 42.0323 48.8685 41.7011 48.8918C41.3702 48.9148 41.261 49.1939 41.261 49.1939Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1157 44.9537L41.8357 44.4095C41.7985 44.3732 41.7712 44.3684 41.7531 44.3721C41.7324 44.3684 41.7011 44.3732 41.6583 44.4095L41.337 44.9537C41.306 45.0063 41.2982 45.0722 41.3156 45.1321C41.3362 45.2025 41.3894 45.2546 41.4539 45.2687L41.728 45.3276V45.339L41.7531 45.3328L41.7819 45.339V45.3257L42.0139 45.2683C42.0703 45.2543 42.1164 45.2021 42.1345 45.1317C42.1496 45.0721 42.143 45.0063 42.1157 44.9537Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0323 45.828H41.4163C41.2983 45.828 41.1976 45.7432 41.1769 45.6266C41.1481 45.4648 41.2721 45.3164 41.4358 45.3164H42.0132C42.1769 45.3164 42.3005 45.4648 42.2721 45.6266C42.2511 45.7429 42.15 45.828 42.0323 45.828Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.261 46.108H42.1876C42.1876 46.108 42.0323 45.7826 41.7011 45.8059C41.3702 45.8292 41.261 46.108 41.261 46.108Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8346 48.0396L44.5547 47.4955C44.5174 47.4592 44.4897 47.4544 44.472 47.4581C44.4514 47.4544 44.42 47.4592 44.3772 47.4955L44.0559 48.0396C44.0249 48.0922 44.0172 48.1581 44.0349 48.2181C44.0556 48.2884 44.1087 48.3406 44.1732 48.3547L44.4473 48.4135V48.425L44.4724 48.4187L44.5012 48.425V48.4117L44.7332 48.3543C44.7896 48.3402 44.8358 48.288 44.8538 48.2177C44.8686 48.1585 44.8616 48.0926 44.8346 48.0396Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.751 48.9139H44.1349C44.0169 48.9139 43.9162 48.8292 43.8955 48.7126C43.8667 48.5508 43.9907 48.4023 44.1545 48.4023H44.7318C44.8956 48.4023 45.0195 48.5508 44.9907 48.7126C44.9701 48.8292 44.869 48.9139 44.751 48.9139Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9796 49.1939H44.9062C44.9062 49.1939 44.7509 48.8685 44.4197 48.8918C44.0884 48.9151 43.9796 49.1939 43.9796 49.1939Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5534 48.0396L47.2734 47.4955C47.2362 47.4592 47.2085 47.4544 47.1908 47.4581C47.1701 47.4544 47.1388 47.4592 47.096 47.4955L46.7747 48.0396C46.7437 48.0922 46.736 48.1581 46.7537 48.2181C46.7743 48.2884 46.8274 48.3406 46.892 48.3547L47.1661 48.4135V48.425L47.1912 48.4187L47.2199 48.425V48.4117L47.452 48.3543C47.5084 48.3402 47.5545 48.288 47.5726 48.2177C47.5873 48.1585 47.5803 48.0926 47.5534 48.0396Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4701 48.9139H46.854C46.736 48.9139 46.6353 48.8292 46.6146 48.7126C46.5862 48.5508 46.7098 48.4023 46.8736 48.4023H47.4509C47.6147 48.4023 47.7386 48.5508 47.7098 48.7126C47.6888 48.8292 47.5877 48.9139 47.4701 48.9139Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6987 49.1939H47.6254C47.6254 49.1939 47.4701 48.8685 47.1388 48.8918C46.8075 48.9148 46.6987 49.1939 46.6987 49.1939Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.691 47.1934L37.4988 46.2188L36.3066 47.1934V54.6374H38.691V47.1934Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4801 47.1934L45.1444 46.2188L43.8087 47.1934V54.6374H46.4801V47.1934Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0897 52.7305H46.1735",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2244 53.6719H46.1735",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7245 48.0797L41.762 46.2188L39.309 48.0797V54.6374H43.7245V48.0797Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5292 47.1934L55.3369 46.2188L54.1451 47.1934V54.6374H56.5292V47.1934Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7034 48.0797L51.4761 46.2188L49.2879 48.0797V54.6374H53.7034V48.0797Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.594 49.7633L60.3726 46.2188L56.7059 49.7633V54.6374H63.594V49.7633Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3276 49.7633L33.0479 46.2188L29.4395 49.7633V54.6374H36.3276V49.7633Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9344 47.1934L47.7422 46.2188L46.5504 47.1934V54.6374H48.9344V47.1934Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8013 52.7305H48.6612",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.921 53.6719H48.661",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8961 49.8594H48.5383",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6235 54.4062H36.2184L34.8052 56.2331H63.3291L63.6235 54.4062Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6234 54.4062H45.9403L45.0287 56.2331H63.4334L63.6234 54.4062Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6069 52.793H38.4778",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6069 53.8555C29.7943 53.8555 38.4778 53.8555 38.4778 53.8555",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4147 52.7266H43.288",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6645 53.668H43.288",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3478 52.7266H53.1583",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2203 52.7266H56.2193",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8751 52.7266H63.138",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3478 53.668H53.4929",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4701 53.668H56.157",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0145 53.668H63.2487",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9065 49.9141H35.8529",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6471 49.8555H43.3846",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7588 49.8555H38.4011",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.291 49.8555H45.9333",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4847 49.8555H56.127",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7845 49.8555H53.522",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3163 49.8555H62.9798",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7806 74.168H120.487V55.5537H91.7806V74.168Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.087 57.6484H120.918V56.0533H112.087V57.6484Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.388 57.635V71.0297L121.889 73.068V74.1315H111.116V72.9795L112.529 70.6751V57.5977L120.388 57.635Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.562 56.6758V71.0322",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.295 68.4612L114.913 68.0625L115.531 68.4612V70.2336H114.295V68.4612Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.109 57.6484H110.939V56.0533H102.109V57.6484Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.409 57.635V71.0297L111.911 73.068V74.1315H101.137V72.9795L102.55 70.6751V57.5977L110.409 57.635Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.584 56.6758V71.0322",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.316 68.4612L104.934 68.0625L105.553 68.4612V70.2336H104.316V68.4612Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.778 70.9062H103.479",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.397 71.7148H113.468",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.397 67.4609H93.3216",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.397 66.5312H93.3216",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.397 65.6016H93.3216",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9692 56.3633V70.9929",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.48 63.5H97.5396V59.8878H94.48V63.5Z",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0794 61.332H98.7094V59.7969H98.0794V61.332Z",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3103 61.332H93.9404V59.7969H93.3103V61.332Z",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3103 63.9492H93.9404V62.4141H93.3103V63.9492Z",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0794 64.2227H98.7094V62.6875H98.0794V64.2227Z",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.02 63.5H106.151V59.8878H104.02V63.5Z",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.527 61.332H106.965V59.7969H106.527V61.332Z",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.206 61.332H103.644V59.7969H103.206V61.332Z",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.206 63.9492H103.644V62.4141H103.206V63.9492Z",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.527 64.2227H106.965V62.6875H106.527V64.2227Z",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.813 63.5H116.142V59.8878H113.813V63.5Z",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.553 61.332H117.033V59.7969H116.553V61.332Z",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.923 61.332H113.402V59.7969H112.923V61.332Z",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.923 63.9492H113.402V62.4141H112.923V63.9492Z",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.553 64.2227H117.033V62.6875H116.553V64.2227Z",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.913 63.4531H111.904V60.1052H110.913V63.4531Z",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.529 63.4531H109.52V60.1052H108.529V63.4531Z",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.464 63.4531H119.454V60.1052H118.464V63.4531Z",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.801 63.4531H101.792V60.1052H100.801V63.4531Z",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.741 44.0078H106.725V42.9187H103.741V44.0078Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.448 45.0078H108.019V43.9187H102.448V45.0078Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.586 46.2422H108.881V45.1531H101.586V46.2422Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.868 47.2578H109.599V46.1687H100.868V47.2578Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.208 48.3516H110.259V47.2625H100.208V48.3516Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.975 41.2617L105.176 40.8711C105.203 40.8452 105.223 40.8419 105.236 40.8445C105.251 40.8419 105.273 40.8452 105.304 40.8711L105.535 41.2617C105.557 41.2994 105.563 41.3468 105.55 41.3898C105.535 41.4405 105.497 41.4779 105.45 41.4879L105.254 41.5301V41.5382L105.236 41.5338L105.215 41.5382V41.5286L105.049 41.4875C105.008 41.4775 104.975 41.4401 104.962 41.3894C104.951 41.3468 104.956 41.2994 104.975 41.2617Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.035 41.8907H105.477C105.562 41.8907 105.634 41.8296 105.649 41.7459C105.67 41.63 105.581 41.5234 105.463 41.5234H105.049C104.931 41.5234 104.843 41.63 104.863 41.7459C104.878 41.8299 104.951 41.8907 105.035 41.8907Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.589 42.0889H104.924C104.924 42.0889 105.035 41.8553 105.273 41.8719C105.511 41.8886 105.589 42.0889 105.589 42.0889Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.613 42.0898C105.613 42.0898 105.962 42.3401 105.896 42.4237C105.829 42.507 105.646 42.4904 105.646 42.4904L105.729 42.8409H104.732L104.882 42.4737C104.882 42.4737 104.483 42.4737 104.649 42.3068C104.741 42.2146 104.948 42.0898 104.948 42.0898H105.613Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.23 48.0396L110.51 47.4955C110.547 47.4592 110.575 47.4544 110.592 47.4581C110.613 47.4544 110.644 47.4592 110.687 47.4955L111.009 48.0396C111.04 48.0922 111.047 48.1581 111.03 48.2181C111.009 48.2884 110.956 48.3406 110.891 48.3547L110.617 48.4135V48.425L110.592 48.4187L110.563 48.425V48.4117L110.331 48.3543C110.275 48.3402 110.229 48.288 110.211 48.2177C110.196 48.1585 110.203 48.0926 110.23 48.0396Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.314 48.9139H110.93C111.048 48.9139 111.149 48.8292 111.169 48.7126C111.198 48.5508 111.074 48.4023 110.91 48.4023H110.333C110.169 48.4023 110.045 48.5508 110.074 48.7126C110.094 48.8292 110.196 48.9139 110.314 48.9139Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.085 49.1939H110.158C110.158 49.1939 110.313 48.8685 110.644 48.8918C110.976 48.9148 111.085 49.1939 111.085 49.1939Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.511 48.0396L107.791 47.4955C107.828 47.4592 107.856 47.4544 107.874 47.4581C107.894 47.4544 107.926 47.4592 107.969 47.4955L108.29 48.0396C108.321 48.0922 108.329 48.1581 108.311 48.2181C108.29 48.2884 108.237 48.3406 108.173 48.3547L107.899 48.4135V48.425L107.873 48.4187L107.845 48.425V48.4117L107.613 48.3543C107.556 48.3402 107.51 48.288 107.492 48.2177C107.477 48.1585 107.484 48.0926 107.511 48.0396Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.595 48.9139H108.211C108.329 48.9139 108.429 48.8292 108.45 48.7126C108.479 48.5508 108.355 48.4023 108.191 48.4023H107.614C107.45 48.4023 107.326 48.5508 107.355 48.7126C107.376 48.8292 107.476 48.9139 107.595 48.9139Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.366 49.1939H107.439C107.439 49.1939 107.595 48.8685 107.926 48.8918C108.257 48.9148 108.366 49.1939 108.366 49.1939Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.792 48.0396L105.072 47.4955C105.109 47.4592 105.137 47.4544 105.155 47.4581C105.175 47.4544 105.207 47.4592 105.249 47.4955L105.571 48.0396C105.602 48.0922 105.609 48.1581 105.592 48.2181C105.571 48.2884 105.518 48.3406 105.453 48.3547L105.179 48.4135V48.425L105.154 48.4187L105.125 48.425V48.4117L104.893 48.3543C104.837 48.3402 104.791 48.288 104.773 48.2177C104.758 48.1585 104.765 48.0926 104.792 48.0396Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.876 48.9139H105.492C105.61 48.9139 105.71 48.8292 105.731 48.7126C105.76 48.5508 105.636 48.4023 105.472 48.4023H104.895C104.731 48.4023 104.608 48.5508 104.636 48.7126C104.657 48.8292 104.758 48.9139 104.876 48.9139Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.647 49.1939H104.72C104.72 49.1939 104.876 48.8685 105.207 48.8918C105.538 48.9148 105.647 49.1939 105.647 49.1939Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.792 44.9537L105.072 44.4095C105.109 44.3732 105.137 44.3684 105.155 44.3721C105.175 44.3684 105.207 44.3732 105.249 44.4095L105.571 44.9537C105.602 45.0063 105.609 45.0722 105.592 45.1321C105.571 45.2025 105.518 45.2546 105.453 45.2687L105.179 45.3276V45.339L105.154 45.3328L105.125 45.339V45.3257L104.893 45.2683C104.837 45.2543 104.791 45.2021 104.773 45.1317C104.758 45.0721 104.765 45.0063 104.792 44.9537Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.876 45.828H105.492C105.61 45.828 105.711 45.7432 105.731 45.6266C105.76 45.4648 105.636 45.3164 105.472 45.3164H104.895C104.731 45.3164 104.608 45.4648 104.636 45.6266C104.657 45.7429 104.758 45.828 104.876 45.828Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.647 46.108H104.72C104.72 46.108 104.876 45.7826 105.207 45.8059C105.538 45.8292 105.647 46.108 105.647 46.108Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.074 48.0396L102.354 47.4955C102.391 47.4592 102.418 47.4544 102.436 47.4581C102.457 47.4544 102.488 47.4592 102.531 47.4955L102.852 48.0396C102.883 48.0922 102.891 48.1581 102.873 48.2181C102.853 48.2884 102.799 48.3406 102.735 48.3547L102.461 48.4135V48.425L102.436 48.4187L102.407 48.425V48.4117L102.175 48.3543C102.119 48.3402 102.072 48.288 102.054 48.2177C102.04 48.1585 102.046 48.0926 102.074 48.0396Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.157 48.9139H102.773C102.891 48.9139 102.992 48.8292 103.012 48.7126C103.041 48.5508 102.917 48.4023 102.753 48.4023H102.176C102.012 48.4023 101.888 48.5508 101.917 48.7126C101.938 48.8292 102.039 48.9139 102.157 48.9139Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.928 49.1939H102.002C102.002 49.1939 102.157 48.8685 102.488 48.8918C102.819 48.9148 102.928 49.1939 102.928 49.1939Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3543 48.0396L99.6343 47.4955C99.6716 47.4592 99.6992 47.4544 99.7169 47.4581C99.7376 47.4544 99.769 47.4592 99.8117 47.4955L100.133 48.0396C100.164 48.0922 100.172 48.1581 100.154 48.2181C100.133 48.2884 100.08 48.3406 100.016 48.3547L99.7417 48.4135V48.425L99.7166 48.4187L99.6878 48.425V48.4117L99.4558 48.3543C99.3993 48.3402 99.3532 48.288 99.3352 48.2177C99.3204 48.1585 99.3274 48.0926 99.3543 48.0396Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4381 48.9139H100.054C100.172 48.9139 100.273 48.8292 100.294 48.7126C100.322 48.5508 100.198 48.4023 100.035 48.4023H99.4573C99.2935 48.4023 99.1695 48.5508 99.1983 48.7126C99.219 48.8292 99.32 48.9139 99.4381 48.9139Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.209 49.1939H99.2828C99.2828 49.1939 99.4381 48.8685 99.7694 48.8918C100.1 48.9148 100.209 49.1939 100.209 49.1939Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.44 44.0078H116.424V42.9187H113.44V44.0078Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.147 45.0078H117.717V43.9187H112.147V45.0078Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.285 46.2422H118.579V45.1531H111.285V46.2422Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.567 47.2578H119.297V46.1687H110.567V47.2578Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.906 48.3516H119.958V47.2625H109.906V48.3516Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.674 41.2617L114.875 40.8711C114.902 40.8452 114.922 40.8419 114.934 40.8445C114.949 40.8419 114.972 40.8452 115.003 40.8711L115.233 41.2617C115.256 41.2994 115.261 41.3468 115.248 41.3898C115.234 41.4405 115.196 41.4779 115.149 41.4879L114.953 41.5301V41.5382L114.934 41.5338L114.914 41.5382V41.5286L114.747 41.4875C114.707 41.4775 114.674 41.4401 114.661 41.3894C114.65 41.3468 114.654 41.2994 114.674 41.2617Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.734 41.8907H115.176C115.26 41.8907 115.333 41.8296 115.348 41.7459C115.368 41.63 115.279 41.5234 115.162 41.5234H114.748C114.63 41.5234 114.541 41.63 114.562 41.7459C114.577 41.8299 114.649 41.8907 114.734 41.8907Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.288 42.0889H114.622C114.622 42.0889 114.734 41.8553 114.972 41.8719C115.209 41.8886 115.288 42.0889 115.288 42.0889Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.312 42.0898C115.312 42.0898 115.661 42.3401 115.594 42.4237C115.528 42.507 115.345 42.4904 115.345 42.4904L115.428 42.8409H114.431L114.58 42.4737C114.58 42.4737 114.181 42.4737 114.348 42.3068C114.439 42.2146 114.647 42.0898 114.647 42.0898H115.312Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.928 48.0396L120.208 47.4955C120.246 47.4592 120.273 47.4544 120.291 47.4581C120.312 47.4544 120.343 47.4592 120.386 47.4955L120.707 48.0396C120.738 48.0922 120.746 48.1581 120.728 48.2181C120.707 48.2884 120.654 48.3406 120.59 48.3547L120.316 48.4135V48.425L120.291 48.4187L120.262 48.4254V48.412L120.03 48.3547C119.974 48.3406 119.928 48.2884 119.91 48.2181C119.894 48.1585 119.901 48.0926 119.928 48.0396Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.012 48.9139H120.628C120.746 48.9139 120.847 48.8292 120.867 48.7126C120.896 48.5508 120.772 48.4023 120.608 48.4023H120.031C119.867 48.4023 119.744 48.5508 119.772 48.7126C119.793 48.8292 119.894 48.9139 120.012 48.9139Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.783 49.1939H119.856C119.856 49.1939 120.012 48.8685 120.343 48.8918C120.674 48.9148 120.783 49.1939 120.783 49.1939Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.21 48.0396L117.49 47.4955C117.527 47.4592 117.554 47.4544 117.572 47.4581C117.593 47.4544 117.624 47.4592 117.667 47.4955L117.988 48.0396C118.019 48.0922 118.027 48.1581 118.009 48.2181C117.989 48.2884 117.936 48.3406 117.871 48.3547L117.597 48.4135V48.425L117.572 48.4187L117.543 48.425V48.4117L117.312 48.355C117.255 48.341 117.209 48.2888 117.191 48.2184C117.176 48.1585 117.182 48.0926 117.21 48.0396Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.293 48.9139H117.909C118.027 48.9139 118.128 48.8292 118.148 48.7126C118.177 48.5508 118.053 48.4023 117.89 48.4023H117.312C117.148 48.4023 117.025 48.5508 117.053 48.7126C117.074 48.8292 117.175 48.9139 117.293 48.9139Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.064 49.1939H117.138C117.138 49.1939 117.293 48.8685 117.624 48.8918C117.955 48.9148 118.064 49.1939 118.064 49.1939Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.491 48.0396L114.771 47.4955C114.808 47.4592 114.836 47.4544 114.853 47.4581C114.874 47.4544 114.905 47.4592 114.948 47.4955L115.269 48.0396C115.3 48.0922 115.308 48.1581 115.29 48.2181C115.27 48.2884 115.217 48.3406 115.152 48.3547L114.878 48.4135V48.425L114.853 48.4187L114.824 48.425V48.4117L114.592 48.3543C114.536 48.3402 114.49 48.288 114.471 48.2177C114.457 48.1585 114.464 48.0926 114.491 48.0396Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.574 48.9139H115.19C115.308 48.9139 115.409 48.8292 115.43 48.7126C115.459 48.5508 115.335 48.4023 115.171 48.4023H114.594C114.43 48.4023 114.306 48.5508 114.335 48.7126C114.355 48.8292 114.456 48.9139 114.574 48.9139Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.346 49.1939H114.419C114.419 49.1939 114.574 48.8685 114.906 48.8918C115.237 48.9148 115.346 49.1939 115.346 49.1939Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.491 44.9537L114.771 44.4095C114.808 44.3732 114.836 44.3684 114.853 44.3721C114.874 44.3684 114.905 44.3732 114.948 44.4095L115.269 44.9537C115.3 45.0063 115.308 45.0722 115.29 45.1321C115.27 45.2025 115.217 45.2546 115.152 45.2687L114.878 45.3276V45.339L114.853 45.3328L114.824 45.339V45.3257L114.592 45.2683C114.536 45.2543 114.49 45.2021 114.471 45.1317C114.457 45.0721 114.464 45.0063 114.491 44.9537Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.574 45.828H115.19C115.308 45.828 115.409 45.7432 115.43 45.6266C115.459 45.4648 115.335 45.3164 115.171 45.3164H114.594C114.43 45.3164 114.306 45.4648 114.335 45.6266C114.355 45.7429 114.456 45.828 114.574 45.828Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.346 46.108H114.419C114.419 46.108 114.574 45.7826 114.906 45.8059C115.237 45.8292 115.346 46.108 115.346 46.108Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.772 48.0396L112.052 47.4955C112.089 47.4592 112.117 47.4544 112.135 47.4581C112.155 47.4544 112.187 47.4592 112.229 47.4955L112.551 48.0396C112.582 48.0922 112.589 48.1581 112.572 48.2181C112.551 48.2884 112.498 48.3406 112.433 48.3547L112.159 48.4135V48.425L112.134 48.4187L112.105 48.425V48.4117L111.873 48.3543C111.817 48.3402 111.771 48.288 111.753 48.2177C111.738 48.1585 111.745 48.0926 111.772 48.0396Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.855 48.9139H112.471C112.589 48.9139 112.69 48.8292 112.711 48.7126C112.739 48.5508 112.616 48.4023 112.452 48.4023H111.875C111.711 48.4023 111.587 48.5508 111.616 48.7126C111.637 48.8292 111.737 48.9139 111.855 48.9139Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.627 49.1939H111.7C111.7 49.1939 111.855 48.8685 112.187 48.8918C112.518 48.9148 112.627 49.1939 112.627 49.1939Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.053 48.0396L109.333 47.4955C109.37 47.4592 109.397 47.4544 109.415 47.4581C109.436 47.4544 109.468 47.4592 109.51 47.4955L109.832 48.0396C109.863 48.0922 109.87 48.1581 109.853 48.2181C109.832 48.2884 109.779 48.3406 109.714 48.3547L109.44 48.4135V48.425L109.415 48.4187L109.386 48.425V48.4117L109.154 48.3543C109.098 48.3402 109.052 48.288 109.034 48.2177C109.019 48.1585 109.026 48.0926 109.053 48.0396Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.137 48.9139H109.753C109.871 48.9139 109.971 48.8292 109.992 48.7126C110.021 48.5508 109.897 48.4023 109.733 48.4023H109.156C108.992 48.4023 108.868 48.5508 108.897 48.7126C108.917 48.8292 109.019 48.9139 109.137 48.9139Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.908 49.1939H108.981C108.981 49.1939 109.137 48.8685 109.468 48.8918C109.799 48.9148 109.908 49.1939 109.908 49.1939Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.916 47.1934L119.108 46.2188L120.3 47.1934V54.6374H117.916V47.1934Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.127 47.1934L111.462 46.2188L112.798 47.1934V54.6374H110.127V47.1934Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.517 52.7305H110.433",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.382 53.6719H110.433",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.882 48.0797L114.844 46.2188L117.297 48.0797V54.6374H112.882V48.0797Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.077 47.1934L101.27 46.2188L102.462 47.1934V54.6374H100.077V47.1934Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.903 48.0797L105.131 46.2188L107.318 48.0797V54.6374H102.903V48.0797Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0128 49.7633L96.2343 46.2188L99.9006 49.7633V54.6374H93.0128V49.7633Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.279 49.7633L123.559 46.2188L127.167 49.7633V54.6374H120.279V49.7633Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.672 47.1934L108.864 46.2188L110.056 47.1934V54.6374H107.672V47.1934Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.805 52.7305H107.945",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.685 53.6719H107.945",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.711 49.8594H108.068",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9829 54.4062H120.388L121.801 56.2331H93.2776L92.9829 54.4062Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9829 54.4062H110.666L111.578 56.2331H93.1733L92.9829 54.4062Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127 52.793H118.129",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127 53.8555C126.812 53.8555 118.129 53.8555 118.129 53.8555",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.192 52.7266H113.319",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.942 53.668H113.319",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.259 52.7266H103.448",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.386 52.7266H100.387",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7313 52.7266H93.4688",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.259 53.668H103.114",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.136 53.668H100.449",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5919 53.668H93.3582",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.7 49.9141H120.754",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.96 49.8555H113.222",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.848 49.8555H118.205",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.315 49.8555H110.673",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.122 49.8555H100.479",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.822 49.8555H103.084",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2902 49.8555H93.6271",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8242 42.4847H126.797L127.662 41.2109H28.7784L29.8242 42.4847Z",
    fill: "#69ABB9",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7784 41.2086H127.662L125.476 39.5469H31.0301L28.7784 41.2086Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9445 23.4164C90.3034 17.0011 84.9074 11.9922 78.3457 11.9922C71.784 11.9922 66.3879 17.0008 65.7465 23.4164H90.9445Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.062 23.4164C86.6183 17.0011 82.8852 11.9922 78.3453 11.9922C73.8055 11.9922 70.0724 17.0008 69.6286 23.4164H87.062Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7236 23.4164C82.5008 17.0011 80.6257 11.9922 78.3457 11.9922C76.0656 11.9922 74.1906 17.0008 73.9678 23.4164H82.7236Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8807 23.4141H65.7465V26.7513H90.8807V23.4141Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1968 21.1055C66.0021 21.7688 65.863 22.4555 65.7781 23.1592H90.8803V22.8997C90.7936 22.2867 90.6645 21.6874 90.4937 21.1055H66.1968Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8807 26.4961H65.7465V28.5499H90.8807V26.4961Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8807 38.3051H65.7465V31.2983L64.4218 30.3125H92.2054L90.8807 31.185V38.3051Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6594 31.2335H90.8807V31.185L92.2054 30.3125H64.4218L65.6594 31.2335Z",
    fill: "#69ABB9",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2054 30.2917H64.4218L65.7465 28.2383H90.8807L92.2054 30.2917Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1991 19.7344C68.6938 19.7344 68.2839 20.1456 68.2839 20.6528V22.9316H70.1143V20.6528C70.1143 20.1456 69.7045 19.7344 69.1991 19.7344Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8247 19.7344C86.3194 19.7344 85.9095 20.1456 85.9095 20.6528V22.9316H87.7399V20.6528C87.7399 20.1456 87.3301 19.7344 86.8247 19.7344Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2154 5.81801L78.3958 4.22548C78.2866 4.11961 78.2062 4.10554 78.1538 4.11628C78.0937 4.10554 78.0014 4.11961 77.8764 4.22548L76.9361 5.81801C76.845 5.97201 76.8221 6.16487 76.8741 6.34071C76.935 6.5469 77.0899 6.69979 77.2788 6.74051L78.0807 6.91301V6.9467L78.1538 6.92856L78.2379 6.9467V6.90783L78.9166 6.74051C79.0815 6.69979 79.2165 6.5469 79.2693 6.34071C79.3147 6.16487 79.2947 5.97238 79.2154 5.81801Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9713 8.37946H77.1693C76.824 8.37946 76.5289 8.13107 76.4684 7.79013C76.3847 7.31704 76.7473 6.88281 77.2261 6.88281H78.9149C79.3937 6.88281 79.7563 7.31704 79.6725 7.79013C79.6117 8.13107 79.3162 8.37946 78.9713 8.37946Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7141 9.19254H79.4257C79.4257 9.19254 78.9709 8.24006 78.0022 8.30817C77.0335 8.37592 76.7141 9.19254 76.7141 9.19254Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6148 9.19178C76.6148 9.19178 75.1913 10.2124 75.4624 10.5522C75.7336 10.8924 76.4795 10.8243 76.4795 10.8243L76.1404 12.2528H80.2078L79.5976 10.7562C79.5976 10.7562 81.2244 10.7562 80.5468 10.0758C80.1723 9.70004 79.3265 9.19141 79.3265 9.19141H76.6148V9.19178Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0462 12.2539V23.2746",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9444 37.8851C90.3033 31.4699 84.9072 26.4609 78.3455 26.4609C71.7839 26.4609 66.3878 31.4695 65.7463 37.8851H90.9444Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0619 37.8851C86.6181 31.4699 82.885 26.4609 78.3452 26.4609C73.8053 26.4609 70.0722 31.4695 69.6285 37.8851H87.0619Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7233 37.8851C82.5005 31.4699 80.6255 26.4609 78.3454 26.4609C76.0654 26.4609 74.1903 31.4695 73.9675 37.8851H82.7233Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1968 35.5742C66.002 36.2376 65.8629 36.9243 65.7781 37.628H90.8802V37.3685C90.7935 36.7555 90.6644 36.1561 90.4936 35.5742H66.1968Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1991 34.207C68.6938 34.207 68.2839 34.6183 68.2839 35.1255V37.4043H70.1143V35.1255C70.1143 34.6183 69.7045 34.207 69.1991 34.207Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8247 34.207C86.3194 34.207 85.9095 34.6183 85.9095 35.1255V37.4043H87.7399V35.1255C87.7399 34.6183 87.3301 34.207 86.8247 34.207Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2154 20.2907L78.3957 18.6981C78.2865 18.5923 78.2061 18.5782 78.1537 18.5889C78.0936 18.5782 78.0014 18.5923 77.8763 18.6981L76.936 20.2907C76.8449 20.4447 76.822 20.6375 76.8741 20.8134C76.9349 21.0196 77.0899 21.1724 77.2787 21.2132L78.0807 21.3857V21.4194L78.1537 21.4012L78.2378 21.4194V21.3805L78.9166 21.2128C79.0815 21.1721 79.2165 21.0192 79.2692 20.813C79.3146 20.6375 79.2947 20.4447 79.2154 20.2907Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9711 22.8521H77.1691C76.8238 22.8521 76.5287 22.6037 76.4682 22.2628C76.3845 21.7897 76.7471 21.3555 77.2259 21.3555H78.9147C79.3935 21.3555 79.7561 21.7897 79.6724 22.2628C79.6115 22.6037 79.316 22.8521 78.9711 22.8521Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7139 23.6652H79.4256C79.4256 23.6652 78.9708 22.7127 78.0021 22.7808C77.0334 22.8489 76.7139 23.6652 76.7139 23.6652Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6147 23.6644C76.6147 23.6644 75.1912 24.685 75.4623 25.0249C75.7334 25.3651 76.4793 25.2969 76.4793 25.2969L76.1403 26.7255H80.2076L79.5975 25.2288C79.5975 25.2288 81.2243 25.2288 80.5466 24.5484C80.1722 24.1727 79.3264 23.6641 79.3264 23.6641L76.6147 23.6644Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.046 26.7305V37.7512",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7463 38.3047L62.2692 40.7253H94.1485L90.8806 38.3047H65.7463Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2692 40.7227L65.0067 43.1155V70.562H91.411V43.5586L94.1485 40.7227H62.2692Z",
    fill: "#BAD8DF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M62.2692 40.7227L65.0067 43.1155V70.562H91.411V43.5586L94.1485 40.7227H62.2692Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2692 40.7227L65.0067 43.1155V70.562H91.411V43.5586L94.1485 40.7227H62.2692Z",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1582 40.7227L70.7127 43.1155V48.6986H85.7052V43.5586L87.2597 40.7227H69.1582Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3844 41.6977H93.2075L94.1485 40.7227H62.2692L63.3844 41.6977Z",
    fill: "#69ABB9",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1143 43.2148H84.3569V44.221H87.1143V43.2148Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3091 44.1367H83.1617V45.1429H88.3091V44.1367Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1056 45.2852H82.3657V46.2913H89.1056V45.2852Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7691 46.2188H81.702V47.2249H89.7691V46.2188Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3797 47.2266H81.0916V48.2327H90.3797V47.2266Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0245 49.082H63.6751V50.4599H92.0245V49.082Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0245 50.4375H63.6751V51.8153H92.0245V50.4375Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0245 51.8008H63.6751V53.1786H92.0245V51.8008Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0245 53.1602H63.6751V54.538H92.0245V53.1602Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9741 41.6794L85.7881 41.3185C85.7634 41.2944 85.7454 41.2911 85.7332 41.2937C85.7195 41.2911 85.6985 41.2944 85.6701 41.3185L85.4569 41.6794C85.4362 41.7142 85.4311 41.7579 85.4429 41.7979C85.4565 41.8445 85.4919 41.8793 85.5347 41.8886L85.7166 41.9278V41.9356L85.7332 41.9315L85.7524 41.9356V41.9267L85.9062 41.889C85.9434 41.8797 85.9741 41.8453 85.9862 41.7983C85.9962 41.7579 85.9918 41.7142 85.9741 41.6794Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9184 42.2571H85.51C85.4318 42.2571 85.365 42.2008 85.351 42.1234C85.3322 42.0161 85.4141 41.918 85.5226 41.918H85.9051C86.0135 41.918 86.0958 42.0164 86.077 42.1234C86.0637 42.2008 85.9966 42.2571 85.9184 42.2571Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4071 42.4394H86.0217C86.0217 42.4394 85.9187 42.2235 85.6989 42.2391C85.4794 42.2546 85.4071 42.4394 85.4071 42.4394Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3846 42.4414C85.3846 42.4414 85.0618 42.6728 85.1234 42.7498C85.185 42.8268 85.354 42.8116 85.354 42.8116L85.2772 43.1355H86.1991L86.0607 42.7964C86.0607 42.7964 86.4296 42.7964 86.2758 42.6424C86.191 42.5573 85.9991 42.4418 85.9991 42.4418L85.3846 42.4414Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1187 47.9408L80.8598 47.4377C80.8255 47.4044 80.8 47.3999 80.7834 47.4033C80.7642 47.3999 80.7351 47.4044 80.6956 47.4377L80.3987 47.9408C80.3699 47.9893 80.3629 48.0503 80.3791 48.1059C80.3983 48.171 80.4474 48.2191 80.5067 48.2321L80.7602 48.2865V48.2973L80.7834 48.2917L80.81 48.2973V48.285L81.0243 48.2321C81.0763 48.2191 81.1191 48.171 81.1357 48.1059C81.1501 48.0503 81.1438 47.9896 81.1187 47.9408Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0417 48.7462H80.4725C80.3637 48.7462 80.2703 48.6677 80.2512 48.56C80.2246 48.4104 80.3393 48.2734 80.4902 48.2734H81.0236C81.1748 48.2734 81.2892 48.4104 81.263 48.56C81.2438 48.6677 81.1505 48.7462 81.0417 48.7462Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3286 49.0068H81.1847C81.1847 49.0068 81.0412 48.7062 80.7351 48.7277C80.4296 48.7491 80.3286 49.0068 80.3286 49.0068Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.631 47.9408L83.3721 47.4377C83.3378 47.4044 83.3123 47.3999 83.2957 47.4033C83.2769 47.3999 83.2478 47.4044 83.2079 47.4377L82.911 47.9408C82.8822 47.9893 82.8748 48.0503 82.8914 48.1059C82.9106 48.171 82.9597 48.2191 83.0191 48.2321L83.2725 48.2865V48.2973L83.2957 48.2917L83.3223 48.2973V48.285L83.5366 48.2321C83.5886 48.2191 83.6314 48.171 83.648 48.1059C83.6624 48.0503 83.6561 47.9896 83.631 47.9408Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5539 48.7462H82.9847C82.8755 48.7462 82.7825 48.6677 82.7634 48.56C82.7368 48.4104 82.8515 48.2734 83.0028 48.2734H83.5362C83.6874 48.2734 83.8018 48.4104 83.7752 48.56C83.756 48.6677 83.6627 48.7462 83.5539 48.7462Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8412 49.0068H83.6974C83.6974 49.0068 83.5539 48.7062 83.2477 48.7277C82.9419 48.7491 82.8412 49.0068 82.8412 49.0068Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1429 47.9408L85.8839 47.4377C85.8496 47.4044 85.8242 47.3999 85.8076 47.4033C85.7888 47.3999 85.7592 47.4044 85.7198 47.4377L85.4228 47.9408C85.3941 47.9893 85.387 48.0503 85.4033 48.1059C85.4225 48.171 85.4715 48.2191 85.5309 48.2321L85.7843 48.2865V48.2973L85.8076 48.2917L85.8341 48.2973V48.285L86.0485 48.2321C86.1005 48.2191 86.1433 48.171 86.1599 48.1059C86.1742 48.0503 86.168 47.9896 86.1429 47.9408Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0658 48.7462H85.4966C85.3875 48.7462 85.2945 48.6677 85.2753 48.56C85.2488 48.4104 85.3635 48.2734 85.5144 48.2734H86.0478C86.199 48.2734 86.3134 48.4104 86.2872 48.56C86.2684 48.6677 86.175 48.7462 86.0658 48.7462Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3531 49.0068H86.2093C86.2093 49.0068 86.0658 48.7062 85.7597 48.7277C85.4539 48.7491 85.3531 49.0068 85.3531 49.0068Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1429 45.0931L85.8839 44.59C85.8496 44.5567 85.8242 44.5523 85.8076 44.5556C85.7888 44.5523 85.7592 44.5567 85.7198 44.59L85.4228 45.0931C85.3941 45.1416 85.387 45.2027 85.4033 45.2582C85.4225 45.3234 85.4715 45.3715 85.5309 45.3844L85.7843 45.4389V45.4496L85.8076 45.4441L85.8341 45.4496V45.4374L86.0485 45.3844C86.1005 45.3715 86.1433 45.3234 86.1599 45.2582C86.1742 45.2027 86.168 45.1416 86.1429 45.0931Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0658 45.8985H85.4966C85.3875 45.8985 85.2945 45.82 85.2753 45.7123C85.2488 45.5627 85.3635 45.4258 85.5144 45.4258H86.0478C86.199 45.4258 86.3134 45.5627 86.2872 45.7123C86.2684 45.82 86.175 45.8985 86.0658 45.8985Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3531 46.1592H86.2093C86.2093 46.1592 86.0658 45.8582 85.7597 45.88C85.4539 45.9011 85.3531 46.1592 85.3531 46.1592Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6553 47.9408L88.3964 47.4377C88.3621 47.4044 88.3366 47.3999 88.32 47.4033C88.3008 47.3999 88.2717 47.4044 88.2322 47.4377L87.9353 47.9408C87.9065 47.9893 87.8995 48.0503 87.9157 48.1059C87.9349 48.171 87.984 48.2191 88.0434 48.2321L88.2968 48.2865V48.2973L88.32 48.2917L88.3466 48.2973V48.285L88.5609 48.2321C88.6129 48.2191 88.6557 48.171 88.6723 48.1059C88.6867 48.0503 88.6804 47.9896 88.6553 47.9408Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5783 48.7462H88.0091C87.9003 48.7462 87.807 48.6677 87.7878 48.56C87.7612 48.4104 87.8759 48.2734 88.0272 48.2734H88.5606C88.7118 48.2734 88.8262 48.4104 88.7996 48.56C88.7804 48.6677 88.6871 48.7462 88.5783 48.7462Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8652 49.0068H88.7214C88.7214 49.0068 88.5779 48.7062 88.2717 48.7277C87.9662 48.7491 87.8652 49.0068 87.8652 49.0068Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1677 47.9408L90.9088 47.4377C90.8745 47.4044 90.849 47.3999 90.8324 47.4033C90.8136 47.3999 90.7841 47.4044 90.7446 47.4377L90.4477 47.9408C90.4189 47.9893 90.4115 48.0503 90.4281 48.1059C90.4473 48.171 90.4963 48.2191 90.5557 48.2321L90.8092 48.2865V48.2973L90.8324 48.2917L90.859 48.2973V48.285L91.0733 48.2321C91.1253 48.2191 91.1681 48.171 91.1847 48.1059C91.1991 48.0503 91.1928 47.9896 91.1677 47.9408Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0906 48.7462H90.5214C90.4122 48.7462 90.3192 48.6677 90.3 48.56C90.2735 48.4104 90.3882 48.2734 90.5391 48.2734H91.0725C91.2237 48.2734 91.3381 48.4104 91.3119 48.56C91.2927 48.6677 91.1994 48.7462 91.0906 48.7462Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3779 49.0068H91.2341C91.2341 49.0068 91.0906 48.7062 90.7844 48.7277C90.4786 48.7491 90.3779 49.0068 90.3779 49.0068Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4924 43.2109H67.735V44.2171H70.4924V43.2109Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6873 44.1367H66.5399V45.1429H71.6873V44.1367Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4833 45.2812H65.7434V46.2874H72.4833V45.2812Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1473 46.2148H65.0802V47.221H73.1473V46.2148Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7578 47.2266H64.4697V48.2327H73.7578V47.2266Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3518 41.6794L69.1663 41.3185C69.1415 41.2944 69.1235 41.2911 69.1113 41.2937C69.0976 41.2911 69.0766 41.2944 69.0482 41.3185L68.835 41.6794C68.8143 41.7142 68.8092 41.7579 68.821 41.7979C68.8346 41.8445 68.87 41.8793 68.9128 41.8886L69.0947 41.9278V41.9356L69.1113 41.9315L69.1301 41.9356V41.9267L69.2839 41.889C69.3212 41.8797 69.3518 41.8453 69.364 41.7983C69.3743 41.7579 69.3699 41.7142 69.3518 41.6794Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2964 42.2571H68.8881C68.8099 42.2571 68.7427 42.2008 68.7291 42.1234C68.7103 42.0161 68.7922 41.918 68.9006 41.918H69.2835C69.392 41.918 69.4742 42.0164 69.455 42.1234C69.4418 42.2008 69.3746 42.2571 69.2964 42.2571Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7852 42.4394H69.3997C69.3997 42.4394 69.2968 42.2235 69.0769 42.2391C68.8575 42.2546 68.7852 42.4394 68.7852 42.4394Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7626 42.4414C68.7626 42.4414 68.4399 42.6728 68.5015 42.7498C68.5631 42.8268 68.732 42.8116 68.732 42.8116L68.6553 43.1355H69.5771L69.4388 42.7964C69.4388 42.7964 69.8077 42.7964 69.6539 42.6424C69.569 42.5573 69.3772 42.4418 69.3772 42.4418L68.7626 42.4414Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4969 47.9408L64.238 47.4377C64.2037 47.4044 64.1782 47.3999 64.1616 47.4033C64.1428 47.3999 64.1133 47.4044 64.0738 47.4377L63.7769 47.9408C63.7481 47.9893 63.7407 48.0503 63.7573 48.1059C63.7765 48.171 63.8256 48.2191 63.885 48.2321L64.1384 48.2865V48.2973L64.1616 48.2917L64.1882 48.2973V48.285L64.4025 48.2321C64.4545 48.2191 64.4973 48.171 64.5139 48.1059C64.5283 48.0503 64.5217 47.9896 64.4969 47.9408Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4195 48.7462H63.8503C63.7411 48.7462 63.6481 48.6677 63.629 48.56C63.6024 48.4104 63.7171 48.2734 63.868 48.2734H64.4014C64.5526 48.2734 64.667 48.4104 64.6408 48.56C64.622 48.6677 64.5287 48.7462 64.4195 48.7462Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7068 49.0068H64.563C64.563 49.0068 64.4195 48.7062 64.1133 48.7277C63.8079 48.7491 63.7068 49.0068 63.7068 49.0068Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.009 47.9408L66.75 47.4377C66.7157 47.4044 66.6903 47.3999 66.6737 47.4033C66.6549 47.3999 66.6257 47.4044 66.5859 47.4377L66.2889 47.9408C66.2601 47.9893 66.2531 48.0503 66.2694 48.1059C66.2885 48.171 66.3376 48.2191 66.397 48.2321L66.6504 48.2865V48.2973L66.6737 48.2917L66.7002 48.2973V48.285L66.9145 48.2321C66.9666 48.2191 67.0094 48.171 67.026 48.1059C67.0403 48.0503 67.0341 47.9896 67.009 47.9408Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9319 48.7462H66.3627C66.2539 48.7462 66.1606 48.6677 66.1414 48.56C66.1149 48.4104 66.2296 48.2734 66.3805 48.2734H66.9139C67.0651 48.2734 67.1794 48.4104 67.1533 48.56C67.1341 48.6677 67.0407 48.7462 66.9319 48.7462Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2192 49.0068H67.0754C67.0754 49.0068 66.9319 48.7062 66.6257 48.7277C66.3199 48.7491 66.2192 49.0068 66.2192 49.0068Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5212 47.9408L69.2623 47.4377C69.228 47.4044 69.2025 47.3999 69.1859 47.4033C69.1671 47.3999 69.138 47.4044 69.0981 47.4377L68.8012 47.9408C68.7724 47.9893 68.765 48.0503 68.7816 48.1059C68.8008 48.171 68.8499 48.2191 68.9093 48.2321L69.1627 48.2865V48.2973L69.1859 48.2917L69.2125 48.2973V48.285L69.4268 48.2321C69.4788 48.2191 69.5216 48.171 69.5382 48.1059C69.5526 48.0503 69.5463 47.9896 69.5212 47.9408Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4441 48.7462H68.8749C68.7657 48.7462 68.6727 48.6677 68.6536 48.56C68.627 48.4104 68.7417 48.2734 68.893 48.2734H69.4264C69.5776 48.2734 69.692 48.4104 69.6654 48.56C69.6462 48.6677 69.5533 48.7462 69.4441 48.7462Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7314 49.0068H69.5876C69.5876 49.0068 69.4441 48.7062 69.1379 48.7277C68.8321 48.7491 68.7314 49.0068 68.7314 49.0068Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5212 45.0892L69.2623 44.5861C69.228 44.5528 69.2025 44.5484 69.1859 44.5517C69.1671 44.5484 69.138 44.5528 69.0981 44.5861L68.8012 45.0892C68.7724 45.1377 68.765 45.1988 68.7816 45.2543C68.8008 45.3195 68.8499 45.3676 68.9093 45.3805L69.1627 45.435V45.4457L69.1859 45.4401L69.2125 45.4457V45.4335L69.4268 45.3805C69.4788 45.3676 69.5216 45.3195 69.5382 45.2543C69.5526 45.1988 69.5463 45.1377 69.5212 45.0892Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4441 45.8946H68.8749C68.7657 45.8946 68.6727 45.8161 68.6536 45.7084C68.627 45.5588 68.7417 45.4219 68.893 45.4219H69.4264C69.5776 45.4219 69.692 45.5588 69.6654 45.7084C69.6462 45.8161 69.5533 45.8946 69.4441 45.8946Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7314 46.1553H69.5876C69.5876 46.1553 69.4441 45.8543 69.1379 45.8761C68.8321 45.8972 68.7314 46.1553 68.7314 46.1553Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0336 47.9408L71.7746 47.4377C71.7403 47.4044 71.7149 47.3999 71.6983 47.4033C71.6795 47.3999 71.6499 47.4044 71.6105 47.4377L71.3135 47.9408C71.2847 47.9893 71.2777 48.0503 71.294 48.1059C71.3131 48.171 71.3622 48.2191 71.4216 48.2321L71.675 48.2865V48.2973L71.6983 48.2917L71.7248 48.2973V48.285L71.9391 48.2321C71.9912 48.2191 72.0339 48.171 72.0505 48.1059C72.0649 48.0503 72.0583 47.9896 72.0336 47.9408Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9565 48.7462H71.3873C71.2782 48.7462 71.1852 48.6677 71.166 48.56C71.1394 48.4104 71.2542 48.2734 71.405 48.2734H71.9384C72.0897 48.2734 72.204 48.4104 72.1779 48.56C72.1587 48.6677 72.0653 48.7462 71.9565 48.7462Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2434 49.0068H72.0996C72.0996 49.0068 71.9561 48.7062 71.6499 48.7277C71.3445 48.7491 71.2434 49.0068 71.2434 49.0068Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5457 47.9408L74.2867 47.4377C74.2524 47.4044 74.227 47.3999 74.2104 47.4033C74.1916 47.3999 74.1624 47.4044 74.1226 47.4377L73.8256 47.9408C73.7969 47.9893 73.7895 48.0503 73.8061 48.1059C73.8253 48.171 73.8743 48.2191 73.9337 48.2321L74.1871 48.2865V48.2973L74.2104 48.2917L74.2369 48.2973V48.285L74.4513 48.2321C74.5033 48.2191 74.5461 48.171 74.5627 48.1059C74.5771 48.0503 74.5708 47.9896 74.5457 47.9408Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4685 48.7462H73.8994C73.7905 48.7462 73.6972 48.6677 73.678 48.56C73.6515 48.4104 73.7662 48.2734 73.9174 48.2734H74.4508C74.6021 48.2734 74.7164 48.4104 74.6899 48.56C74.6707 48.6677 74.5774 48.7462 74.4685 48.7462Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7559 49.0068H74.612C74.612 49.0068 74.4685 48.7062 74.1624 48.7277C73.8566 48.7491 73.7559 49.0068 73.7559 49.0068Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6234 54.5392L61.5986 56.1273H94.1744L91.8766 54.4922L63.6234 54.5392Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0909 56.0859H61.5779V56.7567H94.0909V56.0859Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7824 56.7812L63.9591 60.7V68.7493H66.6538V60.6371L67.4831 56.7812H62.7824Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7824 56.7812L63.0425 57.8255H67.2968L67.4831 56.7812H62.7824Z",
    fill: "#69ABB9",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8403 70.5078H65.278H65.1829H63.69L63.2281 71.2585V72.4783H65.1829H65.278H67.2807V71.2585L66.8403 70.5078Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6439 68.6641H65.2753H65.1916H63.8832L63.4789 69.4148V70.6345H65.1916H65.2753H67.0298V69.4148L66.6439 68.6641Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3636 72.3594H65.286H65.1592H63.1738L62.5596 72.8865V73.7431H65.1592H65.286H67.949V72.8865L67.3636 72.3594Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3815 56.7812L89.5582 60.7V68.7493H92.2529V60.6371L93.0821 56.7812H88.3815Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3815 56.7812L88.6412 57.8255H92.8959L93.0821 56.7812H88.3815Z",
    fill: "#69ABB9",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4393 70.5078H90.877H90.7819H89.2886L88.8271 71.2585V72.4783H90.7819H90.877H92.8793V71.2585L92.4393 70.5078Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2429 68.6641H90.874H90.7906H89.4822L89.0775 69.4148V70.6345H90.7906H90.874H92.6288V69.4148L92.2429 68.6641Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9623 72.3594H90.8851H90.7582H88.7725L88.1587 72.8865V73.7431H90.7582H90.8851H93.5477V72.8865L92.9623 72.3594Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.304 73.5938H11.9772V84.1003H144.304V73.5938Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.049 73.5938H37.2318V84.1003H119.049V73.5938Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4764 73.7295H64.2723L65.5088 69.8008H90.2399L91.4764 73.7295Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4159 69.9766H90.3509",
    stroke: "#69ABB9",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2393 70.5586H90.5273",
    stroke: "#69ABB9",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0626 71.1445H90.704",
    stroke: "#69ABB9",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8859 71.7344H90.8807",
    stroke: "#69ABB9",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7095 72.3164H91.057",
    stroke: "#69ABB9",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5328 72.8984H91.2337",
    stroke: "#69ABB9",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3129 41.4805H76.3987V42.544H79.3129V41.4805Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.576 42.4531H75.1357V43.5167H80.576V42.4531Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4178 43.6602H74.2943V44.7237H81.4178V43.6602Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1186 44.6484H73.5926V45.712H82.1186V44.6484Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7639 45.7188H72.9475V46.7823H82.7639V45.7188Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5024 47.6797H71.2089V49.1356H84.5024V47.6797Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5024 49.1133H71.2089V50.5692H84.5024V49.1133Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5024 50.5547H71.2089V52.0106H84.5024V50.5547Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5024 51.9883H71.2089V53.4442H84.5024V51.9883Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1077 39.8575L77.9114 39.4762C77.8852 39.4507 77.866 39.4474 77.8535 39.4499C77.8391 39.4474 77.817 39.4507 77.7871 39.4762L77.5617 39.8575C77.5399 39.8945 77.5344 39.9408 77.547 39.9826C77.5617 40.0319 77.5986 40.0685 77.644 40.0785L77.8362 40.12V40.1281L77.8539 40.1237L77.8738 40.1281V40.1189L78.0365 40.0789C78.0759 40.0693 78.1084 40.0326 78.1209 39.983C78.1313 39.9408 78.1265 39.8945 78.1077 39.8575Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0491 40.4716H77.6175C77.5348 40.4716 77.464 40.412 77.4496 40.3306C77.4297 40.2173 77.5164 40.1133 77.6311 40.1133H78.0358C78.1505 40.1133 78.2372 40.2173 78.2173 40.3306C78.2025 40.412 78.1317 40.4716 78.0491 40.4716Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5087 40.6696H78.1583C78.1583 40.6696 78.0495 40.4416 77.8174 40.4579C77.585 40.4742 77.5087 40.6696 77.5087 40.6696Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4846 40.668C77.4846 40.668 77.1438 40.9123 77.2087 40.9937C77.2736 41.0752 77.4522 41.0589 77.4522 41.0589L77.371 41.4009H78.3453L78.1992 41.0426C78.1992 41.0426 78.5887 41.0426 78.4264 40.8797C78.3368 40.7898 78.1343 40.668 78.1343 40.668H77.4846Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9762 46.4755L72.7025 45.9439C72.666 45.9084 72.6395 45.904 72.6218 45.9073C72.6018 45.9036 72.5708 45.9084 72.5292 45.9439L72.2152 46.4755C72.185 46.527 72.1772 46.5914 72.1946 46.6499C72.2149 46.7187 72.2665 46.7698 72.3296 46.7831L72.5974 46.8409V46.8524L72.6218 46.8464L72.6498 46.8524V46.8394L72.8763 46.7835C72.9312 46.7698 72.9762 46.7191 72.994 46.6503C73.0094 46.5914 73.0028 46.527 72.9762 46.4755Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8947 47.3275H72.2934C72.1783 47.3275 72.0795 47.2446 72.0595 47.1309C72.0315 46.9732 72.1525 46.8281 72.3126 46.8281H72.8762C73.036 46.8281 73.157 46.9732 73.1293 47.1309C73.1086 47.2446 73.0101 47.3275 72.8947 47.3275Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1414 47.6009H73.0463C73.0463 47.6009 72.8947 47.2829 72.5712 47.3059C72.248 47.3281 72.1414 47.6009 72.1414 47.6009Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6314 46.4755L75.3577 45.9439C75.3212 45.9084 75.2946 45.904 75.2769 45.9073C75.257 45.9036 75.226 45.9084 75.1843 45.9439L74.8704 46.4755C74.8401 46.527 74.8324 46.5914 74.8497 46.6499C74.87 46.7187 74.9217 46.7698 74.9847 46.7831L75.2526 46.8409V46.8524L75.2769 46.8464L75.3049 46.8524V46.8394L75.5314 46.7835C75.5864 46.7698 75.6314 46.7191 75.6491 46.6503C75.6646 46.5914 75.658 46.527 75.6314 46.4755Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5499 47.3275H74.9483C74.8332 47.3275 74.7347 47.2446 74.7144 47.1309C74.6863 46.9732 74.8073 46.8281 74.9671 46.8281H75.5307C75.6904 46.8281 75.8114 46.9732 75.7834 47.1309C75.7639 47.2446 75.665 47.3275 75.5499 47.3275Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7966 47.6009H75.7015C75.7015 47.6009 75.5499 47.2829 75.2264 47.3059C74.9032 47.3281 74.7966 47.6009 74.7966 47.6009Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2865 46.4755L78.0128 45.9439C77.9763 45.9084 77.9498 45.904 77.932 45.9073C77.9121 45.9036 77.8811 45.9084 77.8395 45.9439L77.5255 46.4755C77.4953 46.527 77.4875 46.5914 77.5049 46.6499C77.5252 46.7187 77.5768 46.7698 77.6399 46.7831L77.9077 46.8409V46.8524L77.932 46.8464L77.9601 46.8524V46.8394L78.1866 46.7835C78.2415 46.7698 78.2865 46.7191 78.3043 46.6503C78.3197 46.5914 78.3131 46.527 78.2865 46.4755Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2051 47.3275H77.6034C77.4883 47.3275 77.3895 47.2446 77.3695 47.1309C77.3415 46.9732 77.4625 46.8281 77.6226 46.8281H78.1862C78.346 46.8281 78.467 46.9732 78.4393 47.1309C78.419 47.2446 78.3201 47.3275 78.2051 47.3275Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4518 47.6009H78.3566C78.3566 47.6009 78.205 47.2829 77.8815 47.3059C77.5584 47.3281 77.4518 47.6009 77.4518 47.6009Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2866 43.4638L78.0129 42.9322C77.9764 42.8967 77.9498 42.8922 77.9321 42.8956C77.9122 42.8919 77.8812 42.8967 77.8395 42.9322L77.5256 43.4638C77.4954 43.5153 77.4876 43.5797 77.5049 43.6382C77.5252 43.707 77.5769 43.7581 77.64 43.7714L77.9078 43.8292V43.8406L77.9321 43.8347L77.9601 43.8406V43.8277L78.1866 43.7718C78.2416 43.7581 78.2866 43.7074 78.3043 43.6385C78.3198 43.5797 78.3132 43.5153 78.2866 43.4638Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2051 44.3158H77.6035C77.4884 44.3158 77.3895 44.2329 77.3696 44.1192C77.3416 43.9615 77.4626 43.8164 77.6226 43.8164H78.1863C78.346 43.8164 78.467 43.9612 78.4394 44.1192C78.4191 44.2329 78.3202 44.3158 78.2051 44.3158Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4518 44.5892H78.3567C78.3567 44.5892 78.2051 44.2712 77.8816 44.2942C77.5584 44.3167 77.4518 44.5892 77.4518 44.5892Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9418 46.4755L80.6681 45.9439C80.6316 45.9084 80.6047 45.904 80.5873 45.9073C80.5674 45.9036 80.5364 45.9084 80.4947 45.9439L80.1808 46.4755C80.1506 46.527 80.1428 46.5914 80.1602 46.6499C80.1804 46.7187 80.2321 46.7698 80.2952 46.7831L80.563 46.8409V46.8524L80.5873 46.8464L80.6154 46.8524V46.8394L80.8419 46.7835C80.8968 46.7698 80.9418 46.7191 80.9595 46.6503C80.975 46.5914 80.9684 46.527 80.9418 46.4755Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8603 47.3275H80.2587C80.1436 47.3275 80.0451 47.2446 80.0248 47.1309C79.9968 46.9732 80.1178 46.8281 80.2775 46.8281H80.8411C81.0009 46.8281 81.1219 46.9732 81.0938 47.1309C81.0739 47.2446 80.9754 47.3275 80.8603 47.3275Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1071 47.6009H81.0119C81.0119 47.6009 80.8603 47.2829 80.5368 47.3059C80.2137 47.3281 80.1071 47.6009 80.1071 47.6009Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5972 46.4755L83.3234 45.9439C83.2869 45.9084 83.2604 45.904 83.2427 45.9073C83.2227 45.9036 83.1918 45.9084 83.1501 45.9439L82.8362 46.4755C82.8059 46.527 82.7982 46.5914 82.8155 46.6499C82.8358 46.7187 82.8874 46.7698 82.9505 46.7831L83.2183 46.8409V46.8524L83.2427 46.8464L83.2707 46.8524V46.8394L83.4972 46.7835C83.5522 46.7698 83.5972 46.7191 83.6149 46.6503C83.6304 46.5914 83.6237 46.527 83.5972 46.4755Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5156 47.3275H82.9143C82.7992 47.3275 82.7004 47.2446 82.6804 47.1309C82.6524 46.9732 82.7734 46.8281 82.9335 46.8281H83.4971C83.6569 46.8281 83.7779 46.9732 83.7502 47.1309C83.7292 47.2446 83.6307 47.3275 83.5156 47.3275Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7623 47.6009H83.6672C83.6672 47.6009 83.5156 47.2829 83.1921 47.3059C82.8689 47.3281 82.7623 47.6009 82.7623 47.6009Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2089 53.4441L69.069 55.1229H86.775L84.3463 53.3945L71.2089 53.4441Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6865 55.0781H69.2014V55.787H86.6865V55.0781Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2598 55.8672L71.5638 59.9559V68.4634H74.4119V59.8892L75.3315 55.8672H70.2598Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2598 55.8672L70.5195 56.6823H75.1453L75.3315 55.8672H70.2598Z",
    fill: "#69ABB9",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6088 70.3242H72.9577H72.857H71.2789L70.7909 71.1175V72.4069H72.857H72.9577H75.074V71.1175L74.6088 70.3242Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4017 68.375H72.9549H72.8664H71.4838L71.0563 69.1683V70.4576H72.8664H72.9549H74.8093V69.1683L74.4017 68.375Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1618 72.2734H72.9662H72.832H70.7334L70.0845 72.8306V73.736H72.832H72.9662H75.7805V72.8306L75.1618 72.2734Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5919 55.8672L81.8959 59.9559V68.4634H84.744V59.8892L85.6636 55.8672H80.5919Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5919 55.8672L80.8519 56.6823H85.4773L85.6636 55.8672H80.5919Z",
    fill: "#69ABB9",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9409 70.3281H83.2897H83.189H81.611L81.1229 71.1214V72.4108H83.189H83.2897H85.406V71.1214L84.9409 70.3281Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7336 68.375H83.2868H83.1983H81.8157L81.3882 69.1683V70.4576H83.1983H83.2868H85.1412V69.1683L84.7336 68.375Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4939 72.2773H83.2983H83.164H81.0658L80.4166 72.8345V73.7399H83.164H83.2983H86.1125V72.8345L85.4939 72.2773Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.157 73.9141H97.7249",
    stroke: "#69ABB9",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1227 74.4609H97.7378",
    stroke: "#69ABB9",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0889 75.0039H97.7512",
    stroke: "#69ABB9",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0548 75.5508H97.764",
    stroke: "#69ABB9",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0209 76.0977H97.7773",
    stroke: "#69ABB9",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9866 76.6367H97.7902",
    stroke: "#69ABB9",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9696 76.9102H97.7968",
    stroke: "#69ABB9",
    strokeWidth: 0.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0614 76.9224H56.6371L56.9019 75.4365L56.6371 73.5938H60.0614L59.7966 75.4365L60.0614 76.9224Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9367 76.9224H95.512L95.7772 75.4365L95.512 73.5938H98.9367L98.6715 75.4365L98.9367 76.9224Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.541 76.7344H54.2074V84.0492H101.541V76.7344Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9879 77.0078H101.918",
    stroke: "#69ABB9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9595 77.8516H101.929",
    stroke: "#69ABB9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9312 78.6992H101.94",
    stroke: "#69ABB9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9027 79.5391H101.951",
    stroke: "#69ABB9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8747 80.3789H101.962",
    stroke: "#69ABB9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8463 81.2266H101.973",
    stroke: "#69ABB9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8179 82.0703H101.984",
    stroke: "#69ABB9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7895 82.9141H101.994",
    stroke: "#69ABB9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7611 83.7578H102.006",
    stroke: "#69ABB9",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4774 76.8242H51.6879V84.0487H54.4774V76.8242Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3874 79.1748H51.7775C51.6285 79.1748 51.5075 79.0533 51.5075 78.9038C51.5075 78.7542 51.6285 78.6328 51.7775 78.6328H54.3874C54.5364 78.6328 54.6574 78.7542 54.6574 78.9038C54.6574 79.0533 54.5364 79.1748 54.3874 79.1748Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3874 77.1865H51.7775C51.6285 77.1865 51.5075 77.0651 51.5075 76.9155C51.5075 76.7659 51.6285 76.6445 51.7775 76.6445H54.3874C54.5364 76.6445 54.6574 76.7659 54.6574 76.9155C54.6574 77.0651 54.5364 77.1865 54.3874 77.1865Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4324 80.7954H51.7329C51.6086 80.7954 51.5079 80.6943 51.5079 80.5696C51.5079 80.4448 51.6086 80.3438 51.7329 80.3438H54.4324C54.5567 80.3438 54.6574 80.4448 54.6574 80.5696C54.6574 80.6943 54.5567 80.7954 54.4324 80.7954Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.286 76.8242H101.496V84.0487H104.286V76.8242Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.196 79.1748H101.586C101.437 79.1748 101.316 79.0533 101.316 78.9038C101.316 78.7542 101.437 78.6328 101.586 78.6328H104.196C104.345 78.6328 104.466 78.7542 104.466 78.9038C104.466 79.0533 104.345 79.1748 104.196 79.1748Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.196 77.1865H101.586C101.437 77.1865 101.316 77.0651 101.316 76.9155C101.316 76.7659 101.437 76.6445 101.586 76.6445H104.196C104.345 76.6445 104.466 76.7659 104.466 76.9155C104.466 77.0651 104.345 77.1865 104.196 77.1865Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.241 80.7954H101.541C101.417 80.7954 101.316 80.6943 101.316 80.5696C101.316 80.4448 101.417 80.3438 101.541 80.3438H104.241C104.365 80.3438 104.466 80.4448 104.466 80.5696C104.466 80.6943 104.365 80.7954 104.241 80.7954Z",
    fill: "#BAD8DF",
    stroke: "#69ABB9",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1855_13413"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 152,
    height: 109,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCulturalSites);
export default __webpack_public_path__ + "static/media/Cultural Sites.2e1653874443024f21d4c2a95382ebe0.svg";
export { ForwardRef as ReactComponent };